/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Button from "../components/BSL_Button";
import BSL_TextInput from "../components/BSL_TextInput";
import { fetchTimeout, checkValidJSON } from "../components/Common";
import { updateAPP } from "../redux_store/appState";
import { loadOffering } from "../redux_store/configState";
import { Palette, API_BASE } from "../AppConfig";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import RemoveIcon from "@material-ui/icons/Remove";
import WarningIcon from "@material-ui/icons/Warning";
import AddIcon from "@material-ui/icons/Add";
import ErrorIcon from "@material-ui/icons/Error";
import { Popper, LinearProgress } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import "react-json-view-lite/dist/index.css";
import BSL_Dialog from "../components/BSL_Dialog";
import ManageProductListAncillary from "./ManageProductListAncillary";
import ManageProductListFilter from "./ManageProductListFilter";
import Autocomplete from "react-autocomplete";
import BSL_ControlContainer from "../components/BSL_ControlContainer";
import Draggable from "react-draggable";
import CloseIcon from "@material-ui/icons/Close";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import ManageOfferingRoofSheetGroups from "./ManageOfferingRoofSheetGroups";
import ManageDrawings from "./ManageDrawings";
import ManagePricing from "./ManagePricing";
import BSL_Select from "../components/BSL_Select";
import { LYSAGHT_POAs, CENTENARY_POAs } from "./Helpers/OfferingsHelper";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "98%",
        display: "flex",
        flexDirection: "column",
        height: "95vh",
        overflow: "hidden",
        fontSize: "small",
    },
    container: {
        height: "90vh",
        maxHeight: "calc(100vh - 200px)",
    },
    row: {
        height: "1px",
        background: "#f8f4df",
        "tr:hover": {
            backgroundColor: "rgb(7, 50, 50, 0.42)",
        },
    },
    rowAlt: {
        background: "#ffffff",
    },
    rowCell: {
        fontSize: "12px",
        border: "none",
        margin: "2px 0px 2px 0px",
        padding: "0px 0px 0px 24px",
        color: theme.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
        "&:hover": {
            backgroundColor: "rgb(7, 177, 77, 0.42)",
            cursor: "pointer",
        },
        maxWidth: "300px",
        minWidth: "150px",
    },
    categoryHeadingCell: {
        textAlign: "center",
        backgroundColor: Palette.FieldersOrange + " !important",
        padding: "2px !important",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        borderLeft: "1px solid white !important",
        borderRight: "1px solid white !important",
        position: "sticky",
        top: "0px !important",
    },
    categoryHeadingCellBlank: {
        textAlign: "center",
        backgroundColor: "#ffffff !important",
        padding: "2px !important",
        position: "sticky",
        top: "0px !important",
    },
    headingCell: {
        fontSize: "13px",
        border: "none",
        padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
        fontFamily: theme.typography.fontFamilySecondary,
        backgroundColor: Palette.FieldersBlue,
        lineHeight: "normal",
        zIndex: "5",
    },
    headingRow: {
        backgroundColor: Palette.FieldersBlue,
    },
    categoryHeader: {
        padding: "2px 20px 2px 20px",
        fontSize: "smaller",
        background: "#ffa620",
        marginLeft: "0px",
        height: "100%",
        borderTop: "solid 2px #acacac",
        whiteSpace: "nowrap",
    },
    categorySubHeader: {
        padding: "2px 20px 2px 40px",
        fontSize: "smaller",
        background: "#ffa620",
        marginLeft: "0px",
        height: "100%",
        borderTop: "solid 2px #acacac",
        whiteSpace: "nowrap",
    },
    stickySectionHeader: {
        position: "sticky",
        top: "16px",
        boxShadow: "1px 1px 9px -2px rgb(0 0 0 / 47%)",
    },
    rowHeader: {
        padding: "2px 20px 2px 40px",
        fontSize: "smaller",
        background: "#fcb44957",
        marginLeft: "0px",
        height: "100%",
        borderTop: "solid 2px #acacac",
        whiteSpace: "nowrap",
        verticalAlign: "top",
    },
    rowIndent: {
        width: "20px",
        minWidth: "20px",
        maxWidth: "20px",
        padding: "0px",
    },
    cellInherit: {
        background: "#e3e3e396",
        color: "#b0b0b0",
    },
    noHover: {
        "&:hover": {
            backgroundColor: "transparent !important",
        },
    },
}));

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export default function ManageOffering(props) {
    const dispatch = useDispatch();
    const app_offerings = useSelector((state) => state?.app?.offerings);

    const classes = useStyles();
    const [pricefile, setPricefile] = React.useState(null);
    const [pricefileDescSummary, setPricefileDescSummary] = React.useState(null);
    const [cds_docs, setCDSOffering] = React.useState(null);
    const [lld_docs, setLLDOffering] = React.useState(null);
    const [materialsKeys, setMaterialsKeys] = React.useState(null);
    const [intialise, setIntialise] = React.useState(false);
    const [jsonValid, setJSONValid] = React.useState(false);
    const [visibleSections, setVisibleSections] = React.useState({});
    const [saving, setSaving] = React.useState({}); // not fast enough! hackign with a global var

    if (window.saving === undefined) window.saving = {};

    const [editCell, setEditCell] = React.useState(null);
    const [value, setValue] = React.useState("");
    const [value2, setValue2] = React.useState("");
    const [tab, setTab] = React.useState(window?.F ? 0 : 1);
    const [lysaght, setLysaght] = React.useState(false);
    const config = useSelector((state) => state.config);

    const toggleVisibleSections = (key) => {
        let new_showVariations = { ...visibleSections };
        if (new_showVariations[key] !== undefined) delete new_showVariations[key];
        else new_showVariations[key] = true;
        setVisibleSections(new_showVariations);
    };

    React.useEffect(() => {
        if (tab === 1) {
            setLysaght(true);
        } else {
            setLysaght(false);
        }
    }, [tab]);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "admin/GetOfferingFile?name=ALL_OFFERINGS";
            fetchTimeout(
                api_url,
                {
                    method: "GET",
                },
                90000
            )
                .then((response) => response.json())
                .then((json) => {
                    setPricefileDescSummary(json["PRICE_FILE_DESC_SUMMARY"]);

                    if (json?.["MATERIALS"]) setMaterialsKeys(json["MATERIALS"]);

                    let cds_docs = {};
                    for (let doc of json["CEN_OFFERINGS"]) cds_docs[doc?.id] = doc;
                    setCDSOffering(cds_docs);

                    let lld_docs = {};
                    for (let doc of json["LLD_OFFERINGS"]) lld_docs[doc?.id] = doc;

                    setLLDOffering(lld_docs);
                    setIntialise(true);
                })
                .catch((e) => {
                    setPricefile(null);
                });
        }
    }, [intialise]);

    function padTo2Digits(num) {
        return num.toString().padStart(2, "0");
    }

    function formatDate(date) {
        return [padTo2Digits(date.getDate()), padTo2Digits(date.getMonth() + 1), date.getFullYear()].join("-");
    }

    const DownloadOfferingFile = () => {
        var element = document.createElement("a");
        element.setAttribute(
            "href",
            "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(config, null, 4))
        );
        element.setAttribute(
            "download",
            config.id + "." + config.DocumentType + "." + formatDate(new Date()) + ".json"
        );

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    };

    const rangeFormat = (val) => {
        if (val?.min !== undefined) {
            let min = val?.min;
            if (min?.replace) min = min.replace("Area.ROOF_SHEETING.RoofSheetData.min_pitch", "RoofSheet>min_pitch");
            let max = val?.max;
            if (max?.replace)
                max = max.replace("Area.ROOF_SHEETING.RoofSheetData.max_overhang", "RoofSheet>max_overhang");
            let def = val?.default;
            if (def?.replace) def = def.replace("Area.ROOF_SHEETING.RoofSheetData.min_pitch", "RoofSheet>min_pitch");

            return (
                <div
                    style={{
                        fontSize: "10px",
                    }}
                >
                    <span style={{ color: "#b4a6a6" }}>min:</span> {min}
                    <br />
                    <span style={{ color: "#b4a6a6" }}> max:</span> {max}
                    <br />
                    <span style={{ color: "#b4a6a6" }}> default:</span> {def}
                </div>
            );
        }
        return "→ inherit";
    };

    const collectionFormat = (val, autocomplete_list = []) => {
        if (val === undefined || val === null) {
            return "→ inherit";
        } else if (val && typeof val === "object") {
            let items = [];

            Object.keys(val).map((item) => {
                //header
                items.push(<span style={{ fontWeight: "600" }}>{item}</span>);
                items.push(arrayFormat(val[item], autocomplete_list));
            });
            return <div style={{ display: "flex", fontSize: "10px", flexDirection: "column" }}>{items}</div>;
        }
        return val;
    };

    const arrayFormat = (val, autocomplete_list = []) => {
        if (Array.isArray(val)) {
            let items = [];
            val.map((item) => {
                if (typeof item === "string") {
                    let warning = false;
                    if (autocomplete_list.length > 0 && !autocomplete_list.includes(item)) warning = true;

                    if (item.includes("<R1>")) warning = false;
                    if (item.includes("<LR>")) warning = false;

                    if (items.length < 25)
                        items.push(
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                }}
                            >
                                ◝ {item}{" "}
                                {warning && (
                                    <WarningIcon
                                        style={{
                                            width: "17px",
                                            height: "13px",
                                            color: "#e29d35",
                                        }}
                                    />
                                )}
                            </span>
                        );
                }
                if (typeof item === "object") {
                    let string = JSON.stringify(item);
                    if (string && string.length > 75) string = string.substring(0, 75) + "...";
                    if (items.length < 25) items.push(<span>◝ {string}</span>);
                }
            });
            if (items.length >= 24) items.push(<span>◝ ...{val.length - 25} more</span>);
            return <div style={{ display: "flex", flexDirection: "column" }}>{items}</div>;
        }
        return "→ inherit";
    };

    const objectFormat = (val) => {
        if (val === undefined || val === null) {
            return "→ inherit";
        } else if (val && typeof val === "object") {
            let items = [];

            Object.keys(val).map((item) => {
                if (typeof val[item] === "string")
                    items.push(
                        <div>
                            <span style={{ color: "#b4a6a6", fontWeight: "600" }}>{item}:</span> {val[item]}
                        </div>
                    );
                if (typeof val[item] === "object") {
                    let string = JSON.stringify(val[item]);
                    if (string.length > 100) string = string.substring(0, 100) + "...";
                    items.push(
                        <div>
                            <span style={{ color: "#b4a6a6" }}>{item}:</span> {string}
                        </div>
                    );
                }
            });
            return <div style={{ display: "flex", fontSize: "10px", flexDirection: "column" }}>{items}</div>;
        }
        return val;
    };

    const objectFormatSelection = (val, keysToShow = null) => {
        if (val === undefined || val === null) {
            return "→ inherit";
        } else if (val && typeof val === "object") {
            let items = [];
            keysToShow =
                keysToShow && keysToShow.length > 0
                    ? Object.keys(val).filter((key) => keysToShow.includes(key))
                    : Object.keys(val);

            keysToShow.forEach((item, index) => {
                if (typeof val[item] === "string" || typeof val[item] === "number") {
                    items.push(
                        <div key={item + index}>
                            <span style={{ color: "#b4a6a6", fontWeight: "600" }}>{item}:</span> {val[item]}
                        </div>
                    );
                } else if (typeof val[item] === "object") {
                    let string = JSON.stringify(val[item]);
                    if (string.length > 100) string = string.substring(0, 100) + "...";
                    items.push(
                        <div key={item + index}>
                            <span style={{ color: "#b4a6a6" }}>{item}:</span> {string}
                        </div>
                    );
                }
            });
            return <div style={{ display: "flex", fontSize: "10px", flexDirection: "column" }}>{items}</div>;
        }
        return val;
    };

    const objectFormatCount = (val) => {
        if (val === undefined || val === null) {
            return "→ inherit";
        } else {
            const count = val.length;
            return (
                <div
                    style={{
                        color: "darkred",
                        fontSize: "66%",
                        whiteSpace: "break-spaces",
                    }}
                >
                    {count} x ACTIVE FILTERS
                </div>
            );
        }
    };

    const stringFormat = (val) => {
        if (val !== undefined) {
            return val;
        }
        return "→ inherit";
    };

    const roofSheetFormat = (value) => {
        if (typeof value === "object") {
            return (
                <ManageOfferingRoofSheetGroups
                    brand={lysaght ? "Lysaght" : "Fielders"}
                    materials={materialsKeys}
                    value={value}
                    saveValue={saveValue}
                    product_codes={pricefileDescSummary ? Object.keys(pricefileDescSummary) : []}
                    onClose={() => setEditCell(null)}
                />
            );
        }
        return "→ inherit";
    };

    const drawingFormat = (value) => {
        if (typeof value === "object") {
            return <ManageDrawings materialKeys={materialsKeys} value={value} saveValue={saveValue} />;
        }
        return "→ inherit";
    };

    const pricingFormat = (value) => {
        if (typeof value === "object") {
            return <ManagePricing value={value} saveValue={saveValue} />;
        }
        return "→ inherit";
    };

    const bomFormat = (value) => {
        if (Array.isArray(value)) {
            var parts = "";
            for (var item of value) {
                var qty = item?.Qty;
                if (qty === "" || qty === undefined) qty = "1";
                else if (qty && qty?.includes && qty.includes("=")) qty = "X";
                var code = item?.Code ?? "";
                var conditions = item?.Conditions ? "*" : "";
                var use = item?.Use ? " (" + item?.Use + ")" : "";
                if (code != "") parts += qty + " x " + code + use + conditions + "\n";
            }
            return (
                <div
                    style={{
                        color: "darkred",
                        fontSize: "66%",
                        whiteSpace: "break-spaces",
                    }}
                >
                    {parts}
                </div>
            );
        }
        return "→ inherit";
    };

    const boolFormat = (val) => {
        if (val === undefined) {
            return "→ inherit";
        }
        if (val && val === 1) return "Yes";
        if (val && val === "yes") return "Yes";
        if (val && val === true) return "Yes";
        return "No";
    };
    const selectFormat = (val, autocomplete_list) => {
        if (autocomplete_list.length > 0)
            for (var item of autocomplete_list) {
                if (item.Key === val && item?.Display) return item.Display;
            }
        return "→ inherit";
    };
    const autoFormat = (val, autocomplete_list) => {
        if (val === undefined || val === null) {
            return "→ inherit";
        } else if (Array.isArray(val)) {
            return arrayFormat(val, autocomplete_list);
        } else if (val && typeof val === "object") {
            let string = JSON.stringify(val, null, 4);
            if (string.length > 100) string = string.substring(0, 100) + "...";

            return string;
        }

        let warning = false;
        if (autocomplete_list && val && autocomplete_list.length > 0 && !autocomplete_list.includes(val))
            warning = true;

        if (val.includes("<R1>")) warning = false;
        if (val.includes("<LR>")) warning = false;

        if (warning) {
            return (
                <span>
                    {val}{" "}
                    {warning && (
                        <WarningIcon
                            style={{
                                width: "17px",
                                height: "13px",
                                color: "#e29d35",
                            }}
                        />
                    )}
                </span>
            );
        }
        return val;
    };

    const handleEditCell =
        (title, POA, key_path, type, value, autocomplete_list = []) =>
        (e) => {
            if (editCell || editCell?.noEdit) {
                setValue("");
                setValue2("");
                setEditCell(null);
            } else {
                if (type === "JSON" || typeof type === "function") {
                    setJSONValid(checkValidJSON(value));
                }
                setValue(value);
                setValue2("");
                setEditCell({
                    anchorEl: e.currentTarget,
                    POA: POA,
                    key_path: key_path,
                    title: title,
                    type: type,
                    value: value,
                    autocomplete_list: autocomplete_list,
                });
            }
            e.stopPropagation();
        };

    const saveValue = (POA, key_path, value, template) => {
        let new_docs = lysaght ? { ...lld_docs } : { ...cds_docs };

        let object = new_docs;
        let object_parent = new_docs;

        var stack = (POA + ">" + key_path).split(">");

        let second_last_param = "";
        while (stack.length > (key_path.endsWith(">Key") ? 2 : 1)) {
            second_last_param = stack.shift();
            if (object?.[second_last_param]) {
                object_parent = object;
                object = object[second_last_param];
            } else {
                object[second_last_param] = {};
                object_parent = object;
                object = object[second_last_param];
            }
        }
        let last_param = stack.shift();

        if (last_param === "ADD") {
            object[value] = template;
        } else if (value === "DELETE") {
            let old_obj = { ...object };
            object = {};
            for (var key in old_obj) {
                if (key === last_param) {
                } else object[key] = old_obj[key];
            }
            object_parent[second_last_param] = object;
        } else if (key_path.endsWith(">Key")) {
            let old_obj = { ...object };
            object = {};
            for (var key in old_obj) {
                if (key === last_param) {
                    object[value] = old_obj[key];
                } else object[key] = old_obj[key];
            }
            object_parent[second_last_param] = object;
        } else {
            object[last_param] = value;
            object_parent[second_last_param] = object;
            if (POA !== "MASTER") {
                if (!value === undefined || value === "") delete object[last_param];
            }
        }

        if (!new_docs?.[POA]?.["id"]) new_docs[POA]["id"] = POA;
        if (!new_docs?.[POA]?.["DocumentType"])
            new_docs[POA]["DocumentType"] = lysaght ? "LLD_OFFERING" : "CDS_OFFERING";

        let save_key = (lysaght ? "lysaght" : "fielders") + ">" + POA + ">" + key_path;

        window.saving[save_key] = "SAVE";
        setSaving({ ...window.saving });

        window.save_offering_id = save_key;

        if (window.save_offering_controller) window.save_offering_controller.abort();
        if (window.AbortController) {
            window.save_offering_controller = new AbortController();
        }

        //update locally

        if (app_offerings) {
            if (POA == "MASTER" && app_offerings?.[lysaght ? "Lysaght" : "Fielders"]?.["Master"]) {
                let new_app_offerings = { ...app_offerings };
                new_app_offerings[lysaght ? "Lysaght" : "Fielders"]["Master"] = { ...new_docs[POA] };
                // dispatch(updateAPP("offerings", new_app_offerings));
                dispatch(updateAPP("offerings", new_app_offerings)).then(() => {
                    dispatch(loadOffering());
                });
            } else if (app_offerings?.[lysaght ? "Lysaght" : "Fielders"]?.Regions?.[POA]) {
                let new_app_offerings = { ...app_offerings };
                new_app_offerings[lysaght ? "Lysaght" : "Fielders"].Regions[POA] = { ...new_docs[POA] };
                dispatch(updateAPP("offerings", new_app_offerings)).then(() => {
                    dispatch(loadOffering());
                });
            }
        }

        let api_url = API_BASE() + "admin/UpdateOffering";
        //upload to db
        fetchTimeout(api_url, {
            method: "POST",
            signal: window?.save_offering_controller?.signal,
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                doc: new_docs[POA],
                brand: lysaght ? "lysaght" : "fielders",
                POA: POA,
                key_path: key_path,
                value: value,
            }),
        })
            .then(async (response) => {
                if (window.save_offering_id !== save_key) return; // don't update the front end with server docs
                if (response.status >= 200 && response.status <= 300) {
                    let server_updated_docs = await response.json();

                    let docs = {};
                    for (let doc of server_updated_docs) docs[doc?.id] = doc;

                    lysaght ? setLLDOffering(docs) : setCDSOffering(docs);

                    window.saving[save_key] = null;
                    setSaving({ ...window.saving });
                } else {
                    throw "Error saving values";
                }
                window.saving[save_key] = null;
                setSaving({ ...window.saving });
            })
            .catch((e) => {
                window.saving[save_key] = "Error";
                setSaving({ ...window.saving });
            });

        setValue("");
        setEditCell(null);
    };

    var row_i = 0;

    const FLATROOF_COL = "#dfdfdf";
    const PITCHEDROOF_COL = "#cfdfdf";
    const PORTALROOF_COL = "#bfbfdf";
    const NATIONALCARPORT_COL = "#efbfdf";
    const DECK_COL = "#f48893";
    const LOUVRE_COL = "#846ec9";

    const createDesignRow = (
        title,
        design,
        param,
        param_parent,
        format = "auto",
        autocomplete_list = [],
        master_only = false,
        noEdit = false,
        param_grand_parent = null,
        param_child = null
    ) => {
        let backgroundColour = "";

        switch (design) {
            case "Flat Roof":
                backgroundColour = FLATROOF_COL;
                break;
            case "Pitched Roof":
                backgroundColour = PITCHEDROOF_COL;
                break;
            case "Gable Hip Roof":
                backgroundColour = PORTALROOF_COL;
                break;
            case "National Carport":
                backgroundColour = NATIONALCARPORT_COL;
                break;
            case "Louvre Roof":
                backgroundColour = LOUVRE_COL;
                break;
            case "Flat Deck":
                backgroundColour = DECK_COL;
                break;
            default:
                backgroundColour = "white";
        }

        let POAS = lysaght ? LYSAGHT_POAs : CENTENARY_POAs;
        let docs = lysaght ? lld_docs : cds_docs;

        row_i++;

        return (
            <TableRow hover className={classes.row + " " + (row_i % 2 === 0 ? classes.rowAlt : "")}>
                <TableCell className={classes.rowIndent} style={{ background: backgroundColour }}></TableCell>
                <TableCell className={classes.rowHeader}>{title}</TableCell>
                {POAS.map((POA) => {
                    if (master_only && POA !== "MASTER") return null;
                    let value = "";
                    let edit_cell_path = "";
                    if (design && param_parent && param_grand_parent && param_child) {
                        value =
                            docs?.[POA]?.design_options?.[design]?.[param_grand_parent]?.[param_parent]?.[param]?.[
                                param_child
                            ];
                        edit_cell_path =
                            "design_options>" +
                            design +
                            ">" +
                            param_grand_parent +
                            ">" +
                            param_parent +
                            ">" +
                            param +
                            ">" +
                            param_child;
                    } else if (design && param_parent && param_grand_parent) {
                        value = docs?.[POA]?.design_options?.[design]?.[param_grand_parent]?.[param_parent]?.[param];
                        edit_cell_path =
                            "design_options>" + design + ">" + param_grand_parent + ">" + param_parent + ">" + param;
                    } else if (design && param_parent) {
                        value = docs?.[POA]?.design_options?.[design]?.[param_parent]?.[param];
                        edit_cell_path = "design_options>" + design + ">" + param_parent + ">" + param;
                    } else if (design) {
                        value = docs?.[POA]?.design_options?.[design]?.[param];
                        edit_cell_path = "design_options>" + design + ">" + param;
                    } else if (param_parent) {
                        value = docs?.[POA]?.[param_parent]?.[param];
                        edit_cell_path = param_parent + ">" + param;
                    } else {
                        value = docs?.[POA]?.[param];
                        edit_cell_path = param;
                    }
                    let saving_key = (lysaght ? "lysaght" : "fielders") + ">" + POA + ">" + edit_cell_path;

                    let display = "";
                    if (typeof format === "function") {
                        display = format(value, autocomplete_list);
                    } else if (format === "collection") {
                        display = collectionFormat(value, autocomplete_list);
                        if (!value) value = {};
                    } else if (format === "select") {
                        display = selectFormat(value, autocomplete_list);
                    } else if (format === "bool" || format === "int_bool") {
                        display = boolFormat(value, autocomplete_list);
                    } else if (format === "range") {
                        display = rangeFormat(value, autocomplete_list);
                    } else if (format === "array") {
                        display = arrayFormat(value, autocomplete_list);
                        if (!value) value = [];
                    } else {
                        display = autoFormat(value, autocomplete_list);
                    }

                    if (display === "→ inherit" && POA === "MASTER") display = "";

                    let saving = false;
                    let error = false;
                    if (window.saving && window.saving?.[saving_key]) {
                        if (window.saving?.[saving_key] === "ERROR") error = true;
                        else saving = true;
                    }

                    return (
                        <TableCell
                            key={POA}
                            colSpan={master_only ? POAS.length + 1 : 1}
                            className={
                                classes.rowCell +
                                " " +
                                (display === "→ inherit" ? classes.cellInherit : "") +
                                " " +
                                (param === "roofsheet_types" ? classes.noHover : "")
                            }
                            onClick={(e) =>
                                !noEdit
                                    ? handleEditCell(title, POA, edit_cell_path, format, value, autocomplete_list)(e)
                                    : null
                            }
                        >
                            {display}
                            {saving && <LinearProgress />}
                            {error && <ErrorIcon style={{ color: "red" }} />}
                        </TableCell>
                    );
                })}

                <TableCell key={"FILLER"} style={{ width: "1000px" }}></TableCell>
            </TableRow>
        );
    };

    let editorType = "text";

    if (value === undefined || value === null) {
        editorType = "text";
    } else if (Array.isArray(value)) {
        editorType = "array";
    } else if (value && typeof value === "object") {
        editorType = "JSON";
        if (editCell?.key_path?.includes("_range")) editorType = "range";
    }

    if (editCell?.type === "collection") {
        editorType = "collection";
    } else if (typeof editCell?.type === "function") {
        if (editCell?.key_path?.includes("beam_")) editorType = "collection";
    }

    if (editCell?.type === "array") {
        editorType = "array";
    } else if (editCell?.type === "select") {
        editorType = "select";
    } else if (editCell?.type === "JSON" || editCell?.title.startsWith("STATIC DOCUMENTS")) {
        editorType = "JSON";
    }

    if (editCell?.type === "pricing_tier") editorType = "pricing_tier";
    if (editCell?.title.startsWith("BOM ")) editorType = "BOM";
    if (editCell?.title === "BOM FILTER") editorType = "bom_filter";

    if (editCell?.key_path?.includes("roofsheet_default")) editorType = "roofsheet_default";
    if (editCell?.key_path?.includes("roofsheet_types")) editorType = "roofsheet_types";
    if (editCell?.key_path?.includes("SHAPE")) editorType = "shape";
    if (editCell?.key_path?.includes("BEAMS_AND_POSTS")) editorType = "beams_and_posts";

    let master = lysaght ? lld_docs?.["MASTER"] : cds_docs?.["MASTER"];
    let POAS = lysaght ? LYSAGHT_POAs : CENTENARY_POAs;
    let roofsheet_group_types = master?.roofsheet_types ? Object.keys(master?.roofsheet_types) : [];
    let gutter_types = materialsKeys?.["GUTTERS_NAMES"] ? materialsKeys?.["GUTTERS_NAMES"] : [];
    let downpipe_types = materialsKeys?.["DOWNPIPES_NAMES"] ? materialsKeys?.["DOWNPIPES_NAMES"] : [];
    let infill_types = materialsKeys?.["INFILLS"] ? materialsKeys?.["INFILLS"] : [];
    let beam_types = materialsKeys?.["BEAMS_NAMES"] ? materialsKeys?.["BEAMS_NAMES"] : [];
    let post_types = materialsKeys?.["POSTS_NAMES"] ? materialsKeys?.["POSTS_NAMES"] : [];
    let slat_types = materialsKeys?.["SLATS_NAMES"] ? materialsKeys?.["SLATS_NAMES"] : [];
    let colours = materialsKeys?.["colour_map"] ? materialsKeys?.["colour_map"] : [];
    let colour_arrays = materialsKeys?.["colour_arrays"] ? materialsKeys?.["colour_arrays"] : [];
    let colour_arrays_AND_colours = [...colour_arrays, ...colours];
    let product_codes = pricefileDescSummary ? Object.keys(pricefileDescSummary) : [];

    let attachment_types = master && master["attachment_types"] ? Object.keys(master["attachment_types"]) : [];

    const createArrayEditor = (in_array, parent) => {
        let items = [];
        if (Array.isArray(in_array)) {
            in_array.map((item_value, item_index) => {
                items.push(
                    <div
                        style={{
                            display: "inline-flex",
                        }}
                    >
                        <Autocomplete
                            items={editCell?.autocomplete_list ? editCell?.autocomplete_list : []}
                            shouldItemRender={(item, value) => {
                                if (editCell?.autocomplete_list.length > 30) {
                                    if (item.toLowerCase().startsWith(value.toLowerCase().substring(0, 3))) return true;
                                    return false;
                                }
                                return true;
                            }}
                            autoHighlight={false}
                            getItemValue={(item) => item}
                            renderItem={(item, highlighted) => (
                                <div key={item.id} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                                    {item}
                                </div>
                            )}
                            menuStyle={{
                                zIndex: "999999",
                                position: "absolute",
                                backgroundColor: "whitesmoke",
                                boxShadow: "1px 1px 4px",
                                fontSize: "12px",
                                left: "auto",
                                top: "auto",
                                marginLeft: "9px",
                                marginTop: "0px",
                                textAlign: "left",
                                maxHeight: "250px",
                                overflowY: "auto",
                            }}
                            inputProps={{
                                style: {
                                    zIndex: "1",
                                    font: "200 12px Univers45",
                                    width: "95%",
                                    padding: "4px 0px 4px 8px !important",
                                },
                            }}
                            renderInput={(props) => {
                                return (
                                    <BSL_TextInput
                                        style={{ width: "200px", color: "white", margin: "0px", padding: "0px" }}
                                        value={item_value}
                                        tight={true}
                                        InputProps={{
                                            style: { fontSize: "80%" },
                                            ...props,
                                        }}
                                        onEnter={(e) => {
                                            if (parent) {
                                                let array = Object.assign([], value[parent], {
                                                    [item_index]: e.target.value,
                                                });
                                                let new_value = { ...value };
                                                new_value[parent] = array;
                                                setValue(new_value);
                                            } else {
                                                setValue(Object.assign([], value, { [item_index]: e.target.value }));
                                            }
                                        }}
                                    />
                                );
                            }}
                            value={item_value}
                            onChange={(e) => {
                                if (parent) {
                                    let array = Object.assign([], value[parent], {
                                        [item_index]: e.target.value,
                                    });
                                    let new_value = { ...value };
                                    new_value[parent] = array;
                                    setValue(new_value);
                                } else {
                                    setValue(Object.assign([], value, { [item_index]: e.target.value }));
                                }
                            }}
                            onSelect={(val) => {
                                if (parent) {
                                    let array = Object.assign([], value[parent], {
                                        [item_index]: val,
                                    });
                                    let new_value = { ...value };
                                    new_value[parent] = array;
                                    setValue(new_value);
                                } else {
                                    setValue(Object.assign([], value, { [item_index]: val }));
                                }
                            }}
                        />
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                                if (parent) {
                                    let new_array = [...value[parent]];
                                    new_array.splice(item_index, 1);
                                    let new_value = { ...value };
                                    new_value[parent] = new_array;
                                    setValue(new_value);
                                } else {
                                    let new_item = [...value];
                                    new_item.splice(item_index, 1);
                                    setValue(new_item);
                                }
                            }}
                            style={{}}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    </div>
                );
            });
        }

        items.push(
            <div
                style={{
                    display: "inline-flex",
                }}
            >
                <Autocomplete
                    items={editCell?.autocomplete_list ? editCell?.autocomplete_list : []}
                    shouldItemRender={(item, value) => {
                        if (editCell?.autocomplete_list.length > 30) {
                            if (item.toLowerCase().startsWith(value.toLowerCase().substring(0, 3))) return true;
                            return false;
                        }
                        return true;
                    }}
                    autoHighlight={false}
                    getItemValue={(item) => item}
                    renderItem={(item, highlighted) => (
                        <div key={item.id} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                            {item}
                        </div>
                    )}
                    menuStyle={{
                        zIndex: "999999",
                        position: "absolute",
                        backgroundColor: "whitesmoke",
                        boxShadow: "1px 1px 4px",
                        fontSize: "12px",
                        left: "auto",
                        top: "auto",
                        marginLeft: "9px",
                        marginTop: "0px",
                        textAlign: "left",
                        maxHeight: "250px",
                        overflowY: "auto",
                    }}
                    inputProps={{
                        style: {
                            zIndex: "1",
                            font: "200 12px Univers45",
                            width: "95%",
                            padding: "4px 0px 4px 8px !important",
                        },
                    }}
                    renderInput={(props) => {
                        return (
                            <BSL_TextInput
                                style={{ width: "200px", color: "white", margin: "0px", padding: "0px" }}
                                placeholder={"Add New..."}
                                value={""}
                                tight={true}
                                InputProps={{
                                    style: { fontSize: "80%" },
                                    ...props,
                                }}
                                onEnter={(e) => {
                                    if (parent) {
                                        let new_array = [...value[parent]];
                                        new_array.push(e.target.value);
                                        let new_value = { ...value };
                                        new_value[parent] = new_array;
                                        setValue(new_value);
                                    } else {
                                        let new_item = value ? [...value] : [];
                                        new_item.push(e.target.value);
                                        setValue(new_item);
                                    }
                                }}
                            />
                        );
                    }}
                    value={""}
                    onChange={(e) => {
                        if (parent) {
                            let new_array = [...value[parent]];
                            new_array.push(e.target.value);
                            let new_value = { ...value };
                            new_value[parent] = new_array;
                            setValue(new_value);
                        } else {
                            let new_item = value ? [...value] : [];
                            new_item.push(e.target.value);
                            setValue(new_item);
                        }
                    }}
                    onSelect={(val) => {
                        if (parent) {
                            let new_array = [...value[parent]];
                            new_array.push(val);
                            let new_value = { ...value };
                            new_value[parent] = new_array;
                            setValue(new_value);
                        } else {
                            let new_item = value ? [...value] : [];
                            new_item.push(val);
                            setValue(new_item);
                        }
                    }}
                />
            </div>
        );
        return <div style={{ display: "flex", flexDirection: "column", padding: "10px 10px" }}>{items}</div>;
    };

    const getDesignTemplates = (baseDesign) => {
        const templates = config?.design_options?.[baseDesign]?.design_templates || [];
        return Object.entries(templates);
    };

    const carportTemplates = getDesignTemplates("National Carport");

    return (
        <div className={classes.root}>
            {!intialise && <LinearProgress />}

            {cds_docs && (
                <>
                    <AppBar position="static" color="default">
                        <Tabs
                            value={tab}
                            onChange={(event, newValue) => setTab(newValue)}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                        >
                            <Tab label="Centenary Offering" {...a11yProps(0)} />
                            <Tab label="Lysaght Offering" {...a11yProps(1)} />
                        </Tabs>

                        <TabPanel value={0} index={0}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow className={classes.headingRow}>
                                            <TableCell key={"Options"} colSpan={2} className={classes.headingCell}>
                                                OFFERING
                                            </TableCell>
                                            {POAS.map((POA) => (
                                                <TableCell key={"header" + POA} className={classes.headingCell}>
                                                    {POA}
                                                </TableCell>
                                            ))}

                                            <TableCell
                                                key={"FOLLER"}
                                                className={classes.headingCell}
                                                style={{ width: "1000px" }}
                                            ></TableCell>
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            {/* <TableCell key={"Options"} className={classes.headingCell}></TableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow className={classes.headingRow}>
                                            <TableCell
                                                key={"DIMENSIONS"}
                                                className={classes.categoryHeader}
                                                colSpan={POAS.length + 2}
                                            >
                                                REGION SETTINGS
                                            </TableCell>
                                        </TableRow>
                                        {createDesignRow("STATE", null, "state", "region")}
                                        {createDesignRow("POA", null, "id", "region")}
                                        {createDesignRow("NAME", null, "name", "region")}
                                        {createDesignRow("SUPPORT EMAIL", null, "support_email", "region")}
                                        <TableRow className={classes.headingRow}>
                                            <TableCell
                                                key={"DIMENSIONS"}
                                                className={classes.categoryHeader}
                                                colSpan={POAS.length + 2}
                                            >
                                                LICENSE AGREEMENT
                                            </TableCell>
                                        </TableRow>

                                        {createDesignRow(
                                            "START AGREEMENT DATE",
                                            null,
                                            "start_agreement_date",
                                            "license_agreement"
                                        )}
                                        {createDesignRow(
                                            "RENEW AFTER DAYS",
                                            null,
                                            "renew_after_days",
                                            "license_agreement"
                                        )}
                                        {
                                            <>
                                                <TableRow
                                                    className={classes.headingRow + " " + classes.stickySectionHeader}
                                                >
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        style={{ background: FLATROOF_COL }}
                                                        colSpan={POAS.length + 2}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Pricing Tier");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Pricing Tier"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        PRICING ACCOUNTS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Pricing Tier"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "PRICING TIER ACCOUNTS",
                                                            null,
                                                            "pricing_accounts",
                                                            "region",
                                                            "pricing_tier"
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        }

                                        <TableRow className={classes.headingRow + " " + classes.stickySectionHeader}>
                                            <TableCell
                                                key={"DIMENSIONS"}
                                                className={classes.categoryHeader}
                                                style={{ background: FLATROOF_COL }}
                                                colSpan={POAS.length + 2}
                                            >
                                                <IconButton
                                                    aria-label="delete"
                                                    size="small"
                                                    onClick={() => {
                                                        toggleVisibleSections("Flat Roof");
                                                    }}
                                                    style={{
                                                        height: "14px",
                                                        width: "17px",
                                                        padding: "0px",
                                                    }}
                                                >
                                                    {visibleSections["Flat Roof"] ? (
                                                        <RemoveIcon
                                                            style={{
                                                                height: "12px",
                                                                width: "12px",
                                                            }}
                                                        />
                                                    ) : (
                                                        <AddIcon
                                                            style={{
                                                                height: "12px",
                                                                width: "12px",
                                                            }}
                                                        />
                                                    )}
                                                </IconButton>{" "}
                                                FLAT ROOF DESIGN
                                            </TableCell>
                                        </TableRow>
                                        {visibleSections["Flat Roof"] && (
                                            <>
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: FLATROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Roof - Dimensions");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Roof - Dimensions"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        FLAT DIMENSION LIMITS
                                                    </TableCell>
                                                </TableRow>

                                                {visibleSections["Flat Roof - Dimensions"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "LENGTH RANGE",
                                                            "Flat Roof",
                                                            "length_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "DEPTH RANGE",
                                                            "Flat Roof",
                                                            "depth_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "HEIGHT RANGE",
                                                            "Flat Roof",
                                                            "height_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "PITCH RANGE",
                                                            "Flat Roof",
                                                            "pitch_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG LEFT RANGE",
                                                            "Flat Roof",
                                                            "overhang_left_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG RIGHT RANGE",
                                                            "Flat Roof",
                                                            "overhang_right_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG FRONT RANGE",
                                                            "Flat Roof",
                                                            "overhang_front_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG BACK RANGE",
                                                            "Flat Roof",
                                                            "overhang_back_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG CUTOUT RANGE",
                                                            "Flat Roof",
                                                            "overhang_cutout_range",
                                                            null,
                                                            "range"
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: FLATROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Roof - Materials");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Roof - Materials"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        FLAT ROOFSHEET / GUTTER / DOWNPIPE / SLAT OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Roof - Materials"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "ROOFSHEET GROUPS",
                                                            "Flat Roof",
                                                            "roofsheet_groups",
                                                            null,
                                                            "array",
                                                            roofsheet_group_types
                                                        )}
                                                        {createDesignRow(
                                                            "ROOFSHEET DEFAULT",
                                                            "Flat Roof",
                                                            "roofsheet_default",
                                                            null,
                                                            objectFormat
                                                        )}
                                                        {createDesignRow(
                                                            "GUTTER OPTIONS",
                                                            "Flat Roof",
                                                            "gutter_options",
                                                            null,
                                                            "array",
                                                            gutter_types
                                                        )}
                                                        {createDesignRow(
                                                            "GUTTER DEFAULT",
                                                            "Flat Roof",
                                                            "gutter_default",
                                                            null,
                                                            "auto",
                                                            gutter_types
                                                        )}
                                                        {createDesignRow(
                                                            "DOWNPIPE OPTIONS",
                                                            "Flat Roof",
                                                            "downpipe_options",
                                                            null,
                                                            "array",
                                                            downpipe_types
                                                        )}
                                                        {createDesignRow(
                                                            "DOWNPIPE DEFAULT",
                                                            "Flat Roof",
                                                            "downpipe_default",
                                                            null,
                                                            "auto",
                                                            downpipe_types
                                                        )}
                                                        {createDesignRow(
                                                            "DOWNLIGHT OPTIONS",
                                                            "Flat Roof",
                                                            "downlight_options",
                                                            null,
                                                            "array",
                                                            product_codes
                                                        )}
                                                        {createDesignRow(
                                                            "DOWNLIGHT DEFAULT",
                                                            "Flat Roof",
                                                            "downlight_default",
                                                            null,
                                                            "auto",
                                                            product_codes
                                                        )}
                                                        {createDesignRow(
                                                            "SLAT OPTIONS",
                                                            "Flat Roof",
                                                            "slat_options",
                                                            null,
                                                            "array",
                                                            slat_types
                                                        )}
                                                        {createDesignRow(
                                                            "ALLOW SLATS",
                                                            "Flat Roof",
                                                            "allow_slats",
                                                            null,
                                                            "select",
                                                            [
                                                                { Key: 0, Display: "No" },
                                                                { Key: 1, Display: "Yes" },
                                                            ]
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: FLATROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Roof - POSTS");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Roof - POSTS"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        POSTS OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Roof - POSTS"] && (
                                                    <>
                                                        {createDesignRow("POST NAME", "Flat Roof", "Name", "post")}
                                                        {createDesignRow(
                                                            "POST COLOURS",
                                                            "Flat Roof",
                                                            "colours",
                                                            "post",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT POST COLOUR",
                                                            "Flat Roof",
                                                            "default_colour",
                                                            "post",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "POST OPTIONS",
                                                            "Flat Roof",
                                                            "options",
                                                            "post",
                                                            "collection",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT POST SECTION",
                                                            "Flat Roof",
                                                            "section_default",
                                                            "post",
                                                            "auto",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "FREESTANDING POST OPTIONS",
                                                            "Flat Roof",
                                                            "freestanding_options",
                                                            "post",
                                                            "collection",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT FREESTANDING POST SECTION",
                                                            "Flat Roof",
                                                            "section_freestanding_default",
                                                            "post",
                                                            "auto",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Flat Roof",
                                                            "disabled_on_cyclonic",
                                                            "post",
                                                            "array",
                                                            post_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: FLATROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Roof - BEAM 1");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Roof - BEAM 1"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        BEAM 1 (FASCIA) OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Roof - BEAM 1"] && (
                                                    <>
                                                        {createDesignRow("BEAM 1 NAME", "Flat Roof", "Name", "beam_1")}
                                                        {createDesignRow(
                                                            "BEAM 1 COLOURS",
                                                            "Flat Roof",
                                                            "colours",
                                                            "beam_1",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 1 COLOUR",
                                                            "Flat Roof",
                                                            "default_colour",
                                                            "beam_1",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 1 OPTIONS",
                                                            "Flat Roof",
                                                            "options",
                                                            "beam_1",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 1 SECTION",
                                                            "Flat Roof",
                                                            "section_default",
                                                            "beam_1",
                                                            "auto",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Flat Roof",
                                                            "disabled_on_cyclonic",
                                                            "beam_1",
                                                            "array",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: FLATROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Roof - BEAM 2");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Roof - BEAM 2"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        BEAM 2 (PURLIN) OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Roof - BEAM 2"] && (
                                                    <>
                                                        {createDesignRow("BEAM 2 NAME", "Flat Roof", "Name", "beam_2")}
                                                        {createDesignRow(
                                                            "BEAM 2 COLOURS",
                                                            "Flat Roof",
                                                            "colours",
                                                            "beam_2",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 2 COLOUR",
                                                            "Flat Roof",
                                                            "default_colour",
                                                            "beam_2",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 2 OPTIONS",
                                                            "Flat Roof",
                                                            "options",
                                                            "beam_2",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 2 SECTION",
                                                            "Flat Roof",
                                                            "section_default",
                                                            "beam_2",
                                                            "auto",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "ALLOW OMIT SIDE RETURN BEAMS",
                                                            "Flat Roof",
                                                            "allow_omit_side_beams",
                                                            null,
                                                            "select",
                                                            [
                                                                { Key: 0, Display: "No" },
                                                                { Key: 1, Display: "Yes" },
                                                            ]
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Flat Roof",
                                                            "disabled_on_cyclonic",
                                                            "beam_2",
                                                            "array",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: FLATROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Roof - BEAM 3");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Roof - BEAM 3"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        BEAM 3 (RAFTER) OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Roof - BEAM 3"] && (
                                                    <>
                                                        {createDesignRow("BEAM 3 NAME", "Flat Roof", "Name", "beam_3")}
                                                        {createDesignRow(
                                                            "BEAM 3 COLOURS",
                                                            "Flat Roof",
                                                            "colours",
                                                            "beam_3",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 3 COLOUR",
                                                            "Flat Roof",
                                                            "default_colour",
                                                            "beam_3",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 3 OPTIONS",
                                                            "Flat Roof",
                                                            "options",
                                                            "beam_3",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 3 SECTION",
                                                            "Flat Roof",
                                                            "section_default",
                                                            "beam_3"
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Flat Roof",
                                                            "disabled_on_cyclonic",
                                                            "beam_3",
                                                            "array",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: FLATROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Roof - JOIN BEAM");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Roof - JOIN BEAM"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        JOIN BEAM OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Roof - JOIN BEAM"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "JOIN BEAM NAME",
                                                            "Flat Roof",
                                                            "Name",
                                                            "join_beam"
                                                        )}
                                                        {createDesignRow(
                                                            "JOIN BEAM COLOURS",
                                                            "Flat Roof",
                                                            "colours",
                                                            "join_beam",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT JOIN BEAM COLOUR",
                                                            "Flat Roof",
                                                            "default_colour",
                                                            "join_beam",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "JOIN BEAM OPTIONS",
                                                            "Flat Roof",
                                                            "options",
                                                            "join_beam",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT JOIN BEAM SECTION",
                                                            "Flat Roof",
                                                            "section_default",
                                                            "join_beam"
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Flat Roof",
                                                            "disabled_on_cyclonic",
                                                            "join_beam",
                                                            "array",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: FLATROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Roof - OTHER");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Roof - OTHER"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        OTHER OPTIONS (Flashing/Template/BOM Item/etc...)
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Roof - OTHER"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "RAFTER BRACKET CODE",
                                                            "Flat Roof",
                                                            "rafter_bracket_code"
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT ATTACHMENT TYPE",
                                                            "Flat Roof",
                                                            "default_attachment_type",
                                                            null,
                                                            "auto",
                                                            attachment_types
                                                        )}
                                                        {createDesignRow(
                                                            "FLASHING COLOURS",
                                                            "Flat Roof",
                                                            "flashing_colours",
                                                            null,
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "RIDGE COLOURS",
                                                            "Flat Roof",
                                                            "ridge_colours",
                                                            null,
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "FLASHING CODES",
                                                            "Flat Roof",
                                                            "flashing_codes",
                                                            null,
                                                            "JSON"
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT AREA TEMPLATE",
                                                            "Flat Roof",
                                                            "default_area_template",
                                                            null,
                                                            "JSON"
                                                        )}
                                                        {createDesignRow(
                                                            "BOM ITEMS (FLAT ONLY)",
                                                            "Flat Roof",
                                                            "bom_items",
                                                            null,
                                                            bomFormat
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                        {!lysaght && (
                                            <>
                                                <TableRow
                                                    className={classes.headingRow + " " + classes.stickySectionHeader}
                                                >
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        style={{ background: PITCHEDROOF_COL }}
                                                        colSpan={POAS.length + 2}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Pitched Roof");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Pitched Roof"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        PITCHED ROOF DESIGN
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Pitched Roof"] && (
                                                    <>
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "Pitched Roof - Dimensions"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - Dimensions"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                PITCHED DIMENSION LIMITS
                                                            </TableCell>
                                                        </TableRow>

                                                        {visibleSections["Pitched Roof - Dimensions"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "LENGTH RANGE",
                                                                    "Pitched Roof",
                                                                    "length_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "DEPTH RANGE",
                                                                    "Pitched Roof",
                                                                    "depth_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "HEIGHT RANGE",
                                                                    "Pitched Roof",
                                                                    "height_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "PITCH RANGE",
                                                                    "Pitched Roof",
                                                                    "pitch_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "OVERHANG LEFT RANGE",
                                                                    "Pitched Roof",
                                                                    "overhang_left_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "OVERHANG RIGHT RANGE",
                                                                    "Pitched Roof",
                                                                    "overhang_right_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "OVERHANG FRONT RANGE",
                                                                    "Pitched Roof",
                                                                    "overhang_front_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "OVERHANG BACK RANGE",
                                                                    "Pitched Roof",
                                                                    "overhang_back_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "OVERHANG CUTOUT RANGE",
                                                                    "Pitched Roof",
                                                                    "overhang_cutout_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "Pitched Roof - Materials"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - Materials"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                PITCHED ROOFSHEET / GUTTER / DOWNPIPE / SLAT / INFILL
                                                                OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Pitched Roof - Materials"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "ROOFSHEET GROUPS",
                                                                    "Pitched Roof",
                                                                    "roofsheet_groups",
                                                                    null,
                                                                    "array",
                                                                    roofsheet_group_types
                                                                )}
                                                                {createDesignRow(
                                                                    "ROOFSHEET DEFAULT",
                                                                    "Pitched Roof",
                                                                    "roofsheet_default",
                                                                    null,
                                                                    objectFormat
                                                                )}
                                                                {createDesignRow(
                                                                    "GUTTER OPTIONS",
                                                                    "Pitched Roof",
                                                                    "gutter_options",
                                                                    null,
                                                                    "array",
                                                                    gutter_types
                                                                )}
                                                                {createDesignRow(
                                                                    "GUTTER DEFAULT",
                                                                    "Pitched Roof",
                                                                    "gutter_default",
                                                                    null,
                                                                    "auto",
                                                                    gutter_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DOWNPIPE OPTIONS",
                                                                    "Pitched Roof",
                                                                    "downpipe_options",
                                                                    null,
                                                                    "array",
                                                                    downpipe_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DOWNPIPE DEFAULT",
                                                                    "Pitched Roof",
                                                                    "downpipe_default",
                                                                    null,
                                                                    "auto",
                                                                    downpipe_types
                                                                )}
                                                                {createDesignRow(
                                                                    "INFILL OPTIONS",
                                                                    "Pitched Roof",
                                                                    "infill_options",
                                                                    null,
                                                                    "array",
                                                                    infill_types
                                                                )}
                                                                {createDesignRow(
                                                                    "INFILL DEFAULT",
                                                                    "Pitched Roof",
                                                                    "infill_default",
                                                                    null,
                                                                    "auto",
                                                                    infill_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT POST SECTION",
                                                                    "Pitched Roof",
                                                                    "section_default",
                                                                    "post",
                                                                    "auto",
                                                                    post_types
                                                                )}
                                                                {createDesignRow(
                                                                    "SLAT OPTIONS",
                                                                    "Pitched Roof",
                                                                    "slat_options",
                                                                    null,
                                                                    "array",
                                                                    slat_types
                                                                )}
                                                                {createDesignRow(
                                                                    "ALLOW SLATS",
                                                                    "Pitched Roof",
                                                                    "allow_slats",
                                                                    null,
                                                                    "select",
                                                                    [
                                                                        { Key: 0, Display: "No" },
                                                                        { Key: 1, Display: "Yes" },
                                                                    ]
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"Pitched Roof - POSTS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Pitched Roof - POSTS");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - POSTS"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                POSTS OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Pitched Roof - POSTS"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "POST NAME",
                                                                    "Pitched Roof",
                                                                    "Name",
                                                                    "post"
                                                                )}
                                                                {createDesignRow(
                                                                    "POST COLOURS",
                                                                    "Pitched Roof",
                                                                    "colours",
                                                                    "post",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT POST COLOUR",
                                                                    "Pitched Roof",
                                                                    "default_colour",
                                                                    "post",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "POST OPTIONS",
                                                                    "Pitched Roof",
                                                                    "options",
                                                                    "post",
                                                                    "collection",
                                                                    post_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT POST SECTION",
                                                                    "Pitched Roof",
                                                                    "section_default",
                                                                    "post",
                                                                    "auto",
                                                                    post_types
                                                                )}
                                                                {createDesignRow(
                                                                    "FREESTANDING POST OPTIONS",
                                                                    "Pitched Roof",
                                                                    "freestanding_options",
                                                                    "post",
                                                                    "collection",
                                                                    post_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT FREESTANDING POST SECTION",
                                                                    "Pitched Roof",
                                                                    "section_freestanding_default",
                                                                    "post",
                                                                    "auto",
                                                                    post_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DISABLED FOR CYCLONIC",
                                                                    "Pitched Roof",
                                                                    "disabled_on_cyclonic",
                                                                    "post",
                                                                    "array",
                                                                    post_types
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"Pitched Roof - BEAM 1"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Pitched Roof - BEAM 1");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - BEAM 1"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 1 (RAFTER) OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Pitched Roof - BEAM 1"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 1 NAME",
                                                                    "Pitched Roof",
                                                                    "Name",
                                                                    "beam_1"
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 1 COLOURS",
                                                                    "Pitched Roof",
                                                                    "colours",
                                                                    "beam_1",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 1 COLOUR",
                                                                    "Pitched Roof",
                                                                    "default_colour",
                                                                    "beam_1",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 1 OPTIONS",
                                                                    "Pitched Roof",
                                                                    "options",
                                                                    "beam_1",
                                                                    "collection",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 1 SECTION",
                                                                    "Pitched Roof",
                                                                    "section_default",
                                                                    "beam_1",
                                                                    "auto",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DISABLED FOR CYCLONIC",
                                                                    "Pitched Roof",
                                                                    "disabled_on_cyclonic",
                                                                    "beam_1",
                                                                    "array",
                                                                    beam_types
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"Pitched Roof - BEAM 2"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Pitched Roof - BEAM 2");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - BEAM 2"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 2 (PURLIN ON TOP) OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Pitched Roof - BEAM 2"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 2 NAME",
                                                                    "Pitched Roof",
                                                                    "Name",
                                                                    "beam_2"
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 2 COLOURS",
                                                                    "Pitched Roof",
                                                                    "colours",
                                                                    "beam_2",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 2 COLOUR",
                                                                    "Pitched Roof",
                                                                    "default_colour",
                                                                    "beam_2",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 2 OPTIONS",
                                                                    "Pitched Roof",
                                                                    "options",
                                                                    "beam_2",
                                                                    "collection",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 2 SECTION",
                                                                    "Pitched Roof",
                                                                    "section_default",
                                                                    "beam_2",
                                                                    "auto",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DISABLED FOR CYCLONIC",
                                                                    "Pitched Roof",
                                                                    "disabled_on_cyclonic",
                                                                    "beam_2",
                                                                    "array",
                                                                    beam_types
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"Pitched Roof - BEAM 2 INSET"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "Pitched Roof - BEAM 2 INSET"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - BEAM 2 INSET"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 2 (PURLIN INSET) OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Pitched Roof - BEAM 2 INSET"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 2 NAME",
                                                                    "Pitched Roof",
                                                                    "Name",
                                                                    "beam_2_inset"
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 2 COLOURS",
                                                                    "Pitched Roof",
                                                                    "colours",
                                                                    "beam_2_inset",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 2 COLOUR",
                                                                    "Pitched Roof",
                                                                    "default_colour",
                                                                    "beam_2_inset",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 2 OPTIONS",
                                                                    "Pitched Roof",
                                                                    "options",
                                                                    "beam_2_inset",
                                                                    "collection",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 2 SECTION",
                                                                    "Pitched Roof",
                                                                    "section_default",
                                                                    "beam_2_inset",
                                                                    "auto",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DISABLED FOR CYCLONIC",
                                                                    "Pitched Roof",
                                                                    "disabled_on_cyclonic",
                                                                    "beam_2_inset",
                                                                    "array",
                                                                    beam_types
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"Pitched Roof - BEAM 3"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Pitched Roof - BEAM 3");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - BEAM 3"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 3 (FASCIA BEAM) OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Pitched Roof - BEAM 3"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 3 NAME",
                                                                    "Pitched Roof",
                                                                    "Name",
                                                                    "beam_3"
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 3 COLOURS",
                                                                    "Pitched Roof",
                                                                    "colours",
                                                                    "beam_3",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 3 COLOUR",
                                                                    "Pitched Roof",
                                                                    "default_colour",
                                                                    "beam_3",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 3 OPTIONS",
                                                                    "Pitched Roof",
                                                                    "options",
                                                                    "beam_3",
                                                                    "collection",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 3 SECTION",
                                                                    "Pitched Roof",
                                                                    "section_default",
                                                                    "beam_3"
                                                                )}
                                                                {createDesignRow(
                                                                    "DISABLED FOR CYCLONIC",
                                                                    "Pitched Roof",
                                                                    "disabled_on_cyclonic",
                                                                    "beam_3",
                                                                    "array",
                                                                    beam_types
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"Pitched Roof - BEAM 4"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Pitched Roof - BEAM 4");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - BEAM 4"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 4 (PITCHING BEAM) OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Pitched Roof - BEAM 4"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 3 NAME",
                                                                    "Pitched Roof",
                                                                    "Name",
                                                                    "beam_4"
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 3 COLOURS",
                                                                    "Pitched Roof",
                                                                    "colours",
                                                                    "beam_4",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 3 COLOUR",
                                                                    "Pitched Roof",
                                                                    "default_colour",
                                                                    "beam_4",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 3 OPTIONS",
                                                                    "Pitched Roof",
                                                                    "options",
                                                                    "beam_4",
                                                                    "collection",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 3 SECTION",
                                                                    "Pitched Roof",
                                                                    "section_default",
                                                                    "beam_4"
                                                                )}
                                                                {createDesignRow(
                                                                    "DISABLED FOR CYCLONIC",
                                                                    "Pitched Roof",
                                                                    "disabled_on_cyclonic",
                                                                    "beam_4",
                                                                    "array",
                                                                    beam_types
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PITCHEDROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Pitched Roof - OTHER");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Pitched Roof - OTHER"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                OTHER OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Pitched Roof - OTHER"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "RAFTER BRACKET CODE",
                                                                    "Pitched Roof",
                                                                    "rafter_bracket_code"
                                                                )}
                                                                {createDesignRow(
                                                                    "FLASHING COLOURS",
                                                                    "Pitched Roof",
                                                                    "flashing_colours",
                                                                    null,
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "RIDGE COLOURS",
                                                                    "Pitched Roof",
                                                                    "ridge_colours",
                                                                    null,
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "FLASHING CODES",
                                                                    "Pitched Roof",
                                                                    "flashing_codes",
                                                                    null,
                                                                    "JSON"
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT AREA TEMPLATE",
                                                                    "Pitched Roof",
                                                                    "default_area_template",
                                                                    null,
                                                                    "JSON"
                                                                )}
                                                                {createDesignRow(
                                                                    "BOM ITEMS (PITCHED ONLY)",
                                                                    "Pitched Roof",
                                                                    "bom_items",
                                                                    null,
                                                                    bomFormat
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}

                                        <TableRow className={classes.headingRow + " " + classes.stickySectionHeader}>
                                            <TableCell
                                                key={"DIMENSIONS"}
                                                className={classes.categoryHeader}
                                                style={{ background: PORTALROOF_COL }}
                                                colSpan={POAS.length + 2}
                                            >
                                                <IconButton
                                                    aria-label="delete"
                                                    size="small"
                                                    onClick={() => {
                                                        toggleVisibleSections("Gable Hip Roof");
                                                    }}
                                                    style={{
                                                        height: "14px",
                                                        width: "17px",
                                                        padding: "0px",
                                                    }}
                                                >
                                                    {visibleSections["Gable Hip Roof"] ? (
                                                        <RemoveIcon
                                                            style={{
                                                                height: "12px",
                                                                width: "12px",
                                                            }}
                                                        />
                                                    ) : (
                                                        <AddIcon
                                                            style={{
                                                                height: "12px",
                                                                width: "12px",
                                                            }}
                                                        />
                                                    )}
                                                </IconButton>{" "}
                                                GABLE ROOF DESIGN
                                            </TableCell>
                                        </TableRow>
                                        {visibleSections["Gable Hip Roof"] && (
                                            <>
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: PORTALROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Portal Roof - Dimensions");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Portal Roof - Dimensions"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        GABLE DIMENSION LIMITS
                                                    </TableCell>
                                                </TableRow>

                                                {visibleSections["Portal Roof - Dimensions"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "LENGTH RANGE",
                                                            "Gable Hip Roof",
                                                            "length_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "DEPTH RANGE",
                                                            "Gable Hip Roof",
                                                            "depth_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "HEIGHT RANGE",
                                                            "Gable Hip Roof",
                                                            "height_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "PITCH RANGE",
                                                            "Gable Hip Roof",
                                                            "pitch_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG LEFT RANGE",
                                                            "Gable Hip Roof",
                                                            "overhang_left_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG RIGHT RANGE",
                                                            "Gable Hip Roof",
                                                            "overhang_right_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG FRONT RANGE",
                                                            "Gable Hip Roof",
                                                            "overhang_front_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG BACK RANGE",
                                                            "Gable Hip Roof",
                                                            "overhang_back_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "OVERHANG CUTOUT RANGE",
                                                            "Gable Hip Roof",
                                                            "overhang_cutout_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "MAX FRAME OVERHANG",
                                                            "Gable Hip Roof",
                                                            "max_frame_overhang",
                                                            null,
                                                            "auto"
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: PORTALROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Portal Roof - Materials");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Portal Roof - Materials"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        GABLE ROOFSHEET / GUTTER / DOWNPIPE / SLAT / INFILL OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Portal Roof - Materials"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "ROOFSHEET GROUPS",
                                                            "Gable Hip Roof",
                                                            "roofsheet_groups",
                                                            null,
                                                            "array",
                                                            roofsheet_group_types
                                                        )}
                                                        {createDesignRow(
                                                            "ROOFSHEET DEFAULT",
                                                            "Gable Hip Roof",
                                                            "roofsheet_default",
                                                            null,
                                                            objectFormat
                                                        )}
                                                        {createDesignRow(
                                                            "GUTTER OPTIONS",
                                                            "Gable Hip Roof",
                                                            "gutter_options",
                                                            null,
                                                            "array",
                                                            gutter_types
                                                        )}
                                                        {createDesignRow(
                                                            "GUTTER DEFAULT",
                                                            "Gable Hip Roof",
                                                            "gutter_default",
                                                            null,
                                                            "auto",
                                                            gutter_types
                                                        )}
                                                        {createDesignRow(
                                                            "DOWNPIPE OPTIONS",
                                                            "Gable Hip Roof",
                                                            "downpipe_options",
                                                            null,
                                                            "array",
                                                            downpipe_types
                                                        )}
                                                        {createDesignRow(
                                                            "DOWNPIPE DEFAULT",
                                                            "Gable Hip Roof",
                                                            "downpipe_default",
                                                            null,
                                                            "auto",
                                                            downpipe_types
                                                        )}
                                                        {createDesignRow(
                                                            "INFILL OPTIONS",
                                                            "Gable Hip Roof",
                                                            "infill_options",
                                                            null,
                                                            "array",
                                                            infill_types
                                                        )}
                                                        {createDesignRow(
                                                            "INFILL DEFAULT",
                                                            "Gable Hip Roof",
                                                            "infill_default",
                                                            null,
                                                            "auto",
                                                            infill_types
                                                        )}
                                                        {createDesignRow(
                                                            "INFILL BEAM OPTIONS",
                                                            "Gable Hip Roof",
                                                            "options",
                                                            "infill_beam",
                                                            "array",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "INFILL BEAM DEFAULT",
                                                            "Gable Hip Roof",
                                                            "section_default",
                                                            "infill_beam",
                                                            "auto",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "SLAT OPTIONS",
                                                            "Gable Hip Roof",
                                                            "slat_options",
                                                            null,
                                                            "array",
                                                            slat_types
                                                        )}
                                                        {createDesignRow(
                                                            "ALLOW SLATS",
                                                            "Gable Hip Roof",
                                                            "allow_slats",
                                                            null,
                                                            "select",
                                                            [
                                                                { Key: 0, Display: "No" },
                                                                { Key: 1, Display: "Yes" },
                                                            ]
                                                        )}
                                                        {createDesignRow(
                                                            "ALLOW ROLL TOP RIDGE",
                                                            "Gable Hip Roof",
                                                            "allow_roll_top_ridge",
                                                            null,
                                                            "select",
                                                            [
                                                                { Key: 0, Display: "No" },
                                                                { Key: 1, Display: "Yes" },
                                                            ]
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: PORTALROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Portal Roof - POSTS");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Portal Roof - POSTS"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        POSTS OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Portal Roof - POSTS"] && (
                                                    <>
                                                        {createDesignRow("POST NAME", "Gable Hip Roof", "Name", "post")}
                                                        {createDesignRow(
                                                            "POST COLOURS",
                                                            "Gable Hip Roof",
                                                            "colours",
                                                            "post",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT POST COLOUR",
                                                            "Gable Hip Roof",
                                                            "default_colour",
                                                            "post",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "POST OPTIONS",
                                                            "Gable Hip Roof",
                                                            "options",
                                                            "post",
                                                            "collection",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT POST SECTION",
                                                            "Gable Hip Roof",
                                                            "section_default",
                                                            "post",
                                                            "auto",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "NON-PORTAL POST OPTIONS",
                                                            "Gable Hip Roof",
                                                            "non_portal_options",
                                                            "post",
                                                            "collection",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT NON-PORTAL POST SECTION",
                                                            "Gable Hip Roof",
                                                            "non_portal_section_default",
                                                            "post",
                                                            "auto",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "FREESTANDING POST OPTIONS",
                                                            "Gable Hip Roof",
                                                            "freestanding_options",
                                                            "post",
                                                            "collection",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT FREESTANDING POST SECTION",
                                                            "Gable Hip Roof",
                                                            "section_freestanding_default",
                                                            "post",
                                                            "auto",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Gable Hip Roof",
                                                            "disabled_on_cyclonic",
                                                            "post",
                                                            "array",
                                                            post_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: PORTALROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Portal Roof - BEAM 1");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Portal Roof - BEAM 1"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        BEAM 1 (Rafter) OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Portal Roof - BEAM 1"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "BEAM 1 NAME",
                                                            "Gable Hip Roof",
                                                            "Name",
                                                            "beam_1"
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 1 COLOURS",
                                                            "Gable Hip Roof",
                                                            "colours",
                                                            "beam_1",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 1 COLOUR",
                                                            "Gable Hip Roof",
                                                            "default_colour",
                                                            "beam_1",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 1 OPTIONS",
                                                            "Gable Hip Roof",
                                                            "options",
                                                            "beam_1",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 1 SECTION",
                                                            "Gable Hip Roof",
                                                            "section_default",
                                                            "beam_1",
                                                            "auto",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Gable Hip Roof",
                                                            "disabled_on_cyclonic",
                                                            "beam_1",
                                                            "array",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}
                                                {!lysaght && (
                                                    <>
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: PORTALROOF_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Portal Roof - BEAM 2");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Portal Roof - BEAM 2"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 2 (PURLIN ON TOP) OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Portal Roof - BEAM 2"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 2 NAME",
                                                                    "Gable Hip Roof",
                                                                    "Name",
                                                                    "beam_2"
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 2 COLOURS",
                                                                    "Gable Hip Roof",
                                                                    "colours",
                                                                    "beam_2",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 2 COLOUR",
                                                                    "Gable Hip Roof",
                                                                    "default_colour",
                                                                    "beam_2",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 2 OPTIONS",
                                                                    "Gable Hip Roof",
                                                                    "options",
                                                                    "beam_2",
                                                                    "collection",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 2 SECTION",
                                                                    "Gable Hip Roof",
                                                                    "section_default",
                                                                    "beam_2",
                                                                    "auto",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DISABLED FOR CYCLONIC",
                                                                    "Gable Hip Roof",
                                                                    "disabled_on_cyclonic",
                                                                    "beam_2",
                                                                    "array",
                                                                    beam_types
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: PORTALROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Portal Roof - BEAM 2 INSET");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Portal Roof - BEAM 2 INSET"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        {lysaght
                                                            ? "BEAM 2 (Purlin) OPTIONS"
                                                            : "BEAM 2 (PURLIN INSET) OPTIONS"}
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Portal Roof - BEAM 2 INSET"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "BEAM 2 NAME",
                                                            "Gable Hip Roof",
                                                            "Name",
                                                            "beam_2_inset"
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 2 COLOURS",
                                                            "Gable Hip Roof",
                                                            "colours",
                                                            "beam_2_inset",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 2 COLOUR",
                                                            "Gable Hip Roof",
                                                            "default_colour",
                                                            "beam_2_inset",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 2 OPTIONS",
                                                            "Gable Hip Roof",
                                                            "options",
                                                            "beam_2_inset",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 2 SECTION",
                                                            "Gable Hip Roof",
                                                            "section_default",
                                                            "beam_2_inset",
                                                            "auto",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Gable Hip Roof",
                                                            "disabled_on_cyclonic",
                                                            "beam_2_inset",
                                                            "array",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: PORTALROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Portal Roof - BEAM 3");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Portal Roof - BEAM 3"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        BEAM 3 (Edge Beam) OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Portal Roof - BEAM 3"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "BEAM 3 NAME",
                                                            "Gable Hip Roof",
                                                            "Name",
                                                            "beam_3"
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 3 COLOURS",
                                                            "Gable Hip Roof",
                                                            "colours",
                                                            "beam_3",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 3 COLOUR",
                                                            "Gable Hip Roof",
                                                            "default_colour",
                                                            "beam_3",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 3 OPTIONS",
                                                            "Gable Hip Roof",
                                                            "options",
                                                            "beam_3",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 3 SECTION",
                                                            "Gable Hip Roof",
                                                            "section_default",
                                                            "beam_3"
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Gable Hip Roof",
                                                            "disabled_on_cyclonic",
                                                            "beam_3",
                                                            "array",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: PORTALROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Portal Roof - BEAM 4");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Portal Roof - BEAM 4"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        BEAM 4 (Hip Beam) OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Portal Roof - BEAM 4"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "BEAM 3 NAME",
                                                            "Gable Hip Roof",
                                                            "Name",
                                                            "beam_4"
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 3 COLOURS",
                                                            "Gable Hip Roof",
                                                            "colours",
                                                            "beam_4",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 3 COLOUR",
                                                            "Gable Hip Roof",
                                                            "default_colour",
                                                            "beam_4",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 3 OPTIONS",
                                                            "Gable Hip Roof",
                                                            "options",
                                                            "beam_4",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 3 SECTION",
                                                            "Gable Hip Roof",
                                                            "section_default",
                                                            "beam_4"
                                                        )}
                                                        {createDesignRow(
                                                            "DISABLED FOR CYCLONIC",
                                                            "Gable Hip Roof",
                                                            "disabled_on_cyclonic",
                                                            "beam_4",
                                                            "array",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}

                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: PORTALROOF_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Portal Roof - OTHER");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Portal Roof - OTHER"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        OTHER OPTIONS (Flashing/Template/BOM Item/etc...)
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Portal Roof - OTHER"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "RAFTER BRACKET CODE",
                                                            "Gable Hip Roof",
                                                            "rafter_bracket_code"
                                                        )}
                                                        {createDesignRow(
                                                            "GABLE DOWNLIGHT FAN BRACKET CODE",
                                                            "Gable Hip Roof",
                                                            "gable_fan_code"
                                                        )}
                                                        {createDesignRow(
                                                            "GABLE APEX FAN BRACKET CODE",
                                                            "Gable Hip Roof",
                                                            "gable_apex_fan_code"
                                                        )}

                                                        {createDesignRow(
                                                            "DEFAULT ATTACHMENT TYPE",
                                                            "Gable Hip Roof",
                                                            "default_attachment_type",
                                                            null,
                                                            "auto",
                                                            attachment_types
                                                        )}
                                                        {createDesignRow(
                                                            "FLASHING COLOURS",
                                                            "Gable Hip Roof",
                                                            "flashing_colours",
                                                            null,
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "RIDGE COLOURS",
                                                            "Gable Hip Roof",
                                                            "ridge_colours",
                                                            null,
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "FLASHING CODES",
                                                            "Gable Hip Roof",
                                                            "flashing_codes",
                                                            null,
                                                            "JSON"
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT AREA TEMPLATE",
                                                            "Gable Hip Roof",
                                                            "default_area_template",
                                                            null,
                                                            "JSON"
                                                        )}
                                                        {createDesignRow(
                                                            "BOM ITEMS (GABLE ONLY)",
                                                            "Gable Hip Roof",
                                                            "bom_items",
                                                            null,
                                                            bomFormat
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {lysaght && (
                                            <>
                                                <TableRow
                                                    className={classes.headingRow + " " + classes.stickySectionHeader}
                                                >
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        style={{ background: NATIONALCARPORT_COL }}
                                                        colSpan={POAS.length + 2}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("National Carport");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["National Carport"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        NATIONAL CARPORT DESIGN
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["National Carport"] && (
                                                    <>
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: NATIONALCARPORT_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "National Carport - Materials"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["National Carport - Materials"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                CARPORT ROOFSHEET / GUTTER / DOWNPIPE OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["National Carport - Materials"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "ROOFSHEET GROUPS",
                                                                    "National Carport",
                                                                    "roofsheet_groups",
                                                                    null,
                                                                    "array",
                                                                    roofsheet_group_types
                                                                )}
                                                                {createDesignRow(
                                                                    "ROOFSHEET DEFAULT",
                                                                    "National Carport",
                                                                    "roofsheet_default",
                                                                    null,
                                                                    objectFormat
                                                                )}
                                                                {createDesignRow(
                                                                    "GUTTER OPTIONS",
                                                                    "National Carport",
                                                                    "gutter_options",
                                                                    null,
                                                                    "array",
                                                                    gutter_types
                                                                )}
                                                                {createDesignRow(
                                                                    "GUTTER DEFAULT",
                                                                    "National Carport",
                                                                    "gutter_default",
                                                                    null,
                                                                    "auto",
                                                                    gutter_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DOWNPIPE OPTIONS",
                                                                    "National Carport",
                                                                    "downpipe_options",
                                                                    null,
                                                                    "array",
                                                                    downpipe_types
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: NATIONALCARPORT_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "National Carport - POSTS"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["National Carport - POSTS"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                POSTS OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["National Carport - POSTS"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "POST COLOURS",
                                                                    "National Carport",
                                                                    "colours",
                                                                    "post",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: NATIONALCARPORT_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "National Carport - BEAM 1"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["National Carport - BEAM 1"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 1 (FASCIA) OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["National Carport - BEAM 1"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 1 COLOURS",
                                                                    "National Carport",
                                                                    "colours",
                                                                    "beam_1",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: NATIONALCARPORT_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "National Carport - BEAM 2"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["National Carport - BEAM 2"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 2 (PURLIN) OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["National Carport - BEAM 2"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 2 COLOURS",
                                                                    "National Carport",
                                                                    "colours",
                                                                    "beam_2",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: NATIONALCARPORT_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "National Carport - BEAM 3"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["National Carport - BEAM 3"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 3 (RAFTER) OPTIONS
                                                            </TableCell>
                                                        </TableRow>

                                                        {visibleSections["National Carport - BEAM 3"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 3 COLOURS",
                                                                    "National Carport",
                                                                    "colours",
                                                                    "beam_3",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: NATIONALCARPORT_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "National Carport - OTHER"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["National Carport - OTHER"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                OTHER OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["National Carport - OTHER"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "FLASHING COLOURS",
                                                                    "National Carport",
                                                                    "flashing_colours",
                                                                    null,
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: NATIONALCARPORT_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "National Carport - TEMPLATES"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["National Carport - TEMPLATES"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                DESIGN TEMPLATES
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["National Carport - TEMPLATES"] &&
                                                            carportTemplates.length > 0 &&
                                                            carportTemplates.map(
                                                                ([templateName, templateDetails], index) => (
                                                                    <>
                                                                        <TableRow className={classes.headingRow}>
                                                                            <TableCell
                                                                                className={classes.rowIndent}
                                                                                style={{
                                                                                    background: NATIONALCARPORT_COL,
                                                                                }}
                                                                            ></TableCell>
                                                                            <TableCell
                                                                                key={"DIMENSIONS"}
                                                                                className={classes.categorySubHeader}
                                                                                colSpan={POAS.length + 1}
                                                                            >
                                                                                <IconButton
                                                                                    aria-label="delete"
                                                                                    size="small"
                                                                                    onClick={() => {
                                                                                        toggleVisibleSections(
                                                                                            templateName
                                                                                        );
                                                                                    }}
                                                                                    style={{
                                                                                        height: "14px",
                                                                                        width: "17px",
                                                                                        padding: "0px",
                                                                                    }}
                                                                                >
                                                                                    {visibleSections[templateName] ? (
                                                                                        <RemoveIcon
                                                                                            style={{
                                                                                                height: "12px",
                                                                                                width: "12px",
                                                                                            }}
                                                                                        />
                                                                                    ) : (
                                                                                        <AddIcon
                                                                                            style={{
                                                                                                height: "12px",
                                                                                                width: "12px",
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                </IconButton>{" "}
                                                                                {templateName.toUpperCase()}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                        {visibleSections[templateName] && (
                                                                            <>
                                                                                {createDesignRow(
                                                                                    "SHAPE",
                                                                                    "National Carport",
                                                                                    "SHAPE",
                                                                                    templateName,
                                                                                    objectFormatSelection,
                                                                                    [
                                                                                        "Length",
                                                                                        "Depth",
                                                                                        "Height",
                                                                                        "RoofPitch",
                                                                                    ],
                                                                                    false,
                                                                                    false,
                                                                                    "design_templates"
                                                                                )}
                                                                                {createDesignRow(
                                                                                    "BEAMS & POSTS",
                                                                                    "National Carport",
                                                                                    "BEAMS_AND_POSTS",
                                                                                    templateName,
                                                                                    objectFormat,
                                                                                    [beam_types, post_types],
                                                                                    false,
                                                                                    false,
                                                                                    "design_templates"
                                                                                )}
                                                                                {createDesignRow(
                                                                                    "BOM ADDITIONS",
                                                                                    "National Carport",
                                                                                    "bom_items",
                                                                                    templateName,
                                                                                    bomFormat,
                                                                                    [],
                                                                                    false,
                                                                                    false,
                                                                                    "design_templates",
                                                                                    "add"
                                                                                )}
                                                                                {createDesignRow(
                                                                                    "BOM FILTER",
                                                                                    "National Carport",
                                                                                    "bom_items",
                                                                                    templateName,
                                                                                    objectFormatCount,
                                                                                    [],
                                                                                    false,
                                                                                    false,
                                                                                    "design_templates",
                                                                                    "filter"
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </>
                                                                )
                                                            )}
                                                    </>
                                                )}
                                            </>
                                        )}

                                        <TableRow className={classes.headingRow + " " + classes.stickySectionHeader}>
                                            <TableCell
                                                key={"DIMENSIONS"}
                                                className={classes.categoryHeader}
                                                style={{ background: DECK_COL }}
                                                colSpan={POAS.length + 2}
                                            >
                                                <IconButton
                                                    aria-label="delete"
                                                    size="small"
                                                    onClick={() => {
                                                        toggleVisibleSections("Flat Deck");
                                                    }}
                                                    style={{
                                                        height: "14px",
                                                        width: "17px",
                                                        padding: "0px",
                                                    }}
                                                >
                                                    {visibleSections["Flat Deck"] ? (
                                                        <RemoveIcon
                                                            style={{
                                                                height: "12px",
                                                                width: "12px",
                                                            }}
                                                        />
                                                    ) : (
                                                        <AddIcon
                                                            style={{
                                                                height: "12px",
                                                                width: "12px",
                                                            }}
                                                        />
                                                    )}
                                                </IconButton>{" "}
                                                DECK DESIGN
                                            </TableCell>
                                        </TableRow>
                                        {visibleSections["Flat Deck"] && (
                                            <>
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: DECK_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Deck - Dimensions");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Deck - Dimensions"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        DECK DIMENSION LIMITS
                                                    </TableCell>
                                                </TableRow>

                                                {visibleSections["Flat Deck - Dimensions"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "DEPTH RANGE",
                                                            "Flat Deck",
                                                            "length_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "LENGTH RANGE",
                                                            "Flat Deck",
                                                            "depth_range",
                                                            null,
                                                            "range"
                                                        )}
                                                        {createDesignRow(
                                                            "HEIGHT RANGE",
                                                            "Flat Deck",
                                                            "height_range",
                                                            null,
                                                            "range"
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: DECK_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Deck - POSTS");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Deck - POSTS"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        POSTS OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Deck - POSTS"] && (
                                                    <>
                                                        {createDesignRow("POST NAME", "Flat Deck", "Name", "post")}
                                                        {createDesignRow(
                                                            "POST COLOURS",
                                                            "Flat Deck",
                                                            "colours",
                                                            "post",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT POST COLOUR",
                                                            "Flat Deck",
                                                            "default_colour",
                                                            "post",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "POST OPTIONS",
                                                            "Flat Deck",
                                                            "options",
                                                            "post",
                                                            "collection",
                                                            post_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT POST SECTION",
                                                            "Flat Deck",
                                                            "section_default",
                                                            "post",
                                                            "auto",
                                                            post_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: DECK_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Deck - BEAM 1");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Deck - BEAM 1"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        BEARER OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Deck - BEAM 1"] && (
                                                    <>
                                                        {createDesignRow("BEAM 1 NAME", "Flat Deck", "Name", "beam_1")}
                                                        {createDesignRow(
                                                            "BEAM 1 COLOURS",
                                                            "Flat Deck",
                                                            "colours",
                                                            "beam_1",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 1 COLOUR",
                                                            "Flat Deck",
                                                            "default_colour",
                                                            "beam_1",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 1 OPTIONS",
                                                            "Flat Deck",
                                                            "options",
                                                            "beam_1",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 1 SECTION",
                                                            "Flat Deck",
                                                            "section_default",
                                                            "beam_1",
                                                            "auto",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: DECK_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Deck - BEAM 2");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Deck - BEAM 2"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        JOIST OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Deck - BEAM 2"] && (
                                                    <>
                                                        {createDesignRow("BEAM 2 NAME", "Flat Deck", "Name", "beam_2")}
                                                        {createDesignRow(
                                                            "BEAM 2 COLOURS",
                                                            "Flat Deck",
                                                            "colours",
                                                            "beam_2",
                                                            "auto",
                                                            colour_arrays_AND_colours
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 2 COLOUR",
                                                            "Flat Deck",
                                                            "default_colour",
                                                            "beam_2",
                                                            "auto",
                                                            colours
                                                        )}
                                                        {createDesignRow(
                                                            "BEAM 2 OPTIONS",
                                                            "Flat Deck",
                                                            "options",
                                                            "beam_2",
                                                            "collection",
                                                            beam_types
                                                        )}
                                                        {createDesignRow(
                                                            "DEFAULT BEAM 2 SECTION",
                                                            "Flat Deck",
                                                            "section_default",
                                                            "beam_2",
                                                            "auto",
                                                            beam_types
                                                        )}
                                                    </>
                                                )}

                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: DECK_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"BRACING"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Deck - BRACING");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Deck - BRACING"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        BRACING OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Deck - BRACING"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "STRAP BRACE CODE",
                                                            "Flat Deck",
                                                            "strap_brace_code",
                                                            "bracing",
                                                            "auto",
                                                            product_codes
                                                        )}
                                                        {createDesignRow(
                                                            "STRAP ROLL LENGTH (m)",
                                                            "Flat Deck",
                                                            "strap_brace_roll_length",
                                                            "bracing",
                                                            "auto"
                                                        )}
                                                        {createDesignRow(
                                                            "WIRE BRACE CODE",
                                                            "Flat Deck",
                                                            "wire_brace_code",
                                                            "bracing",
                                                            "auto",
                                                            product_codes
                                                        )}
                                                        {createDesignRow(
                                                            "WIRE ROLL LENGTH (m)",
                                                            "Flat Deck",
                                                            "wire_brace_roll_length",
                                                            "bracing",
                                                            "auto"
                                                        )}
                                                        {createDesignRow(
                                                            "ROD BRACE CODE",
                                                            "Flat Deck",
                                                            "rod_brace_code",
                                                            "bracing",
                                                            "auto",
                                                            product_codes
                                                        )}
                                                        {createDesignRow(
                                                            "FLOOR BRACE CODE",
                                                            "Flat Deck",
                                                            "floor_brace_code",
                                                            "bracing",
                                                            "auto",
                                                            product_codes
                                                        )}
                                                        {createDesignRow(
                                                            "FLOOR BRACE AREA PER 30m ROLL (m2)",
                                                            "Flat Deck",
                                                            "floor_brace_area",
                                                            "bracing",
                                                            "auto"
                                                        )}
                                                    </>
                                                )}
                                                <TableRow className={classes.headingRow}>
                                                    <TableCell
                                                        className={classes.rowIndent}
                                                        style={{ background: DECK_COL }}
                                                    ></TableCell>
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        colSpan={POAS.length + 1}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Flat Deck - OTHER");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Flat Deck - OTHER"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        OTHER OPTIONS
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Flat Deck - OTHER"] && (
                                                    <>
                                                        {createDesignRow(
                                                            "DEFAULT AREA TEMPLATE",
                                                            "Flat Deck",
                                                            "default_area_template",
                                                            null,
                                                            "JSON"
                                                        )}
                                                        {createDesignRow(
                                                            "BOM ITEMS (DECK ONLY)",
                                                            "Flat Deck",
                                                            "bom_items",
                                                            null,
                                                            bomFormat
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {lysaght && (
                                            <>
                                                <TableRow
                                                    className={classes.headingRow + " " + classes.stickySectionHeader}
                                                >
                                                    <TableCell
                                                        key={"DIMENSIONS"}
                                                        className={classes.categoryHeader}
                                                        style={{ background: LOUVRE_COL }}
                                                        colSpan={POAS.length + 2}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => {
                                                                toggleVisibleSections("Louvre Roof");
                                                            }}
                                                            style={{
                                                                height: "14px",
                                                                width: "17px",
                                                                padding: "0px",
                                                            }}
                                                        >
                                                            {visibleSections["Louvre Roof"] ? (
                                                                <RemoveIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <AddIcon
                                                                    style={{
                                                                        height: "12px",
                                                                        width: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>{" "}
                                                        LOUVRE ROOF DESIGN
                                                    </TableCell>
                                                </TableRow>
                                                {visibleSections["Louvre Roof"] && (
                                                    <>
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: LOUVRE_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "Louvre Roof - Dimensions"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Louvre Roof - Dimensions"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                LOUVRE ROOF DIMENSION LIMITS
                                                            </TableCell>
                                                        </TableRow>

                                                        {visibleSections["Louvre Roof - Dimensions"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "LENGTH RANGE",
                                                                    "Louvre Roof",
                                                                    "length_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "DEPTH RANGE",
                                                                    "Louvre Roof",
                                                                    "depth_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                                {createDesignRow(
                                                                    "HEIGHT RANGE",
                                                                    "Louvre Roof",
                                                                    "height_range",
                                                                    null,
                                                                    "range"
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: LOUVRE_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections(
                                                                            "Louvre Roof - Materials"
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Louvre Roof - Materials"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                LOUVRE ROOFSHEET / GUTTER / DOWNPIPE / SLAT OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Louvre Roof - Materials"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "ROOFSHEET GROUPS",
                                                                    "Louvre Roof",
                                                                    "roofsheet_groups",
                                                                    null,
                                                                    "array",
                                                                    roofsheet_group_types
                                                                )}
                                                                {createDesignRow(
                                                                    "ROOFSHEET DEFAULT",
                                                                    "Louvre Roof",
                                                                    "roofsheet_default",
                                                                    null,
                                                                    objectFormat
                                                                )}
                                                                {createDesignRow(
                                                                    "GUTTER OPTIONS",
                                                                    "Louvre Roof",
                                                                    "gutter_options",
                                                                    null,
                                                                    "array",
                                                                    gutter_types
                                                                )}
                                                                {createDesignRow(
                                                                    "GUTTER DEFAULT",
                                                                    "Louvre Roof",
                                                                    "gutter_default",
                                                                    null,
                                                                    "auto",
                                                                    gutter_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DOWNPIPE OPTIONS",
                                                                    "Louvre Roof",
                                                                    "downpipe_options",
                                                                    null,
                                                                    "array",
                                                                    downpipe_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DOWNPIPE DEFAULT",
                                                                    "Louvre Roof",
                                                                    "downpipe_default",
                                                                    null,
                                                                    "auto",
                                                                    downpipe_types
                                                                )}
                                                                {createDesignRow(
                                                                    "SLAT OPTIONS",
                                                                    "Louvre Roof",
                                                                    "slat_options",
                                                                    null,
                                                                    "array",
                                                                    slat_types
                                                                )}
                                                                {createDesignRow(
                                                                    "ALLOW SLATS",
                                                                    "Louvre Roof",
                                                                    "allow_slats",
                                                                    null,
                                                                    "select",
                                                                    [
                                                                        { Key: 0, Display: "No" },
                                                                        { Key: 1, Display: "Yes" },
                                                                    ]
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: LOUVRE_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Louvre Roof - POSTS");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Louvre Roof - POSTS"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                POSTS OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Louvre Roof - POSTS"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "POST NAME",
                                                                    "Louvre Roof",
                                                                    "Name",
                                                                    "post"
                                                                )}
                                                                {createDesignRow(
                                                                    "POST COLOURS",
                                                                    "Louvre Roof",
                                                                    "colours",
                                                                    "post",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT POST COLOUR",
                                                                    "Louvre Roof",
                                                                    "default_colour",
                                                                    "post",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "POST OPTIONS",
                                                                    "Louvre Roof",
                                                                    "options",
                                                                    "post",
                                                                    "collection",
                                                                    post_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT POST SECTION",
                                                                    "Louvre Roof",
                                                                    "section_default",
                                                                    "post",
                                                                    "auto",
                                                                    post_types
                                                                )}
                                                            </>
                                                        )}
                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: LOUVRE_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Louvre Roof - BEAM 1");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Louvre Roof - BEAM 1"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                BEAM 1 OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Louvre Roof - BEAM 1"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "BEAM 1 NAME",
                                                                    "Louvre Roof",
                                                                    "Name",
                                                                    "beam_1"
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 1 COLOURS",
                                                                    "Louvre Roof",
                                                                    "colours",
                                                                    "beam_1",
                                                                    "auto",
                                                                    colour_arrays_AND_colours
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 1 COLOUR",
                                                                    "Louvre Roof",
                                                                    "default_colour",
                                                                    "beam_1",
                                                                    "auto",
                                                                    colours
                                                                )}
                                                                {createDesignRow(
                                                                    "BEAM 1 OPTIONS",
                                                                    "Louvre Roof",
                                                                    "options",
                                                                    "beam_1",
                                                                    "collection",
                                                                    beam_types
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT BEAM 1 SECTION",
                                                                    "Louvre Roof",
                                                                    "section_default",
                                                                    "beam_1",
                                                                    "auto",
                                                                    beam_types
                                                                )}
                                                            </>
                                                        )}

                                                        <TableRow className={classes.headingRow}>
                                                            <TableCell
                                                                className={classes.rowIndent}
                                                                style={{ background: LOUVRE_COL }}
                                                            ></TableCell>
                                                            <TableCell
                                                                key={"DIMENSIONS"}
                                                                className={classes.categoryHeader}
                                                                colSpan={POAS.length + 1}
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        toggleVisibleSections("Louvre Roof - OTHER");
                                                                    }}
                                                                    style={{
                                                                        height: "14px",
                                                                        width: "17px",
                                                                        padding: "0px",
                                                                    }}
                                                                >
                                                                    {visibleSections["Louvre Roof - OTHER"] ? (
                                                                        <RemoveIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <AddIcon
                                                                            style={{
                                                                                height: "12px",
                                                                                width: "12px",
                                                                            }}
                                                                        />
                                                                    )}
                                                                </IconButton>{" "}
                                                                OTHER OPTIONS
                                                            </TableCell>
                                                        </TableRow>
                                                        {visibleSections["Louvre Roof - OTHER"] && (
                                                            <>
                                                                {createDesignRow(
                                                                    "Access Level",
                                                                    "Louvre Roof",
                                                                    "access_level",
                                                                    null
                                                                )}
                                                                {createDesignRow(
                                                                    "DEFAULT AREA TEMPLATE",
                                                                    "Louvre Roof",
                                                                    "default_area_template",
                                                                    null,
                                                                    "JSON"
                                                                )}
                                                                {createDesignRow(
                                                                    "BOM ITEMS (LOUVRE ROOF ONLY)",
                                                                    "Louvre Roof",
                                                                    "bom_items",
                                                                    null,
                                                                    bomFormat
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}

                                        <TableRow className={classes.headingRow}>
                                            <TableCell
                                                key={"DIMENSIONS"}
                                                className={classes.categoryHeader}
                                                colSpan={POAS.length + 2}
                                            >
                                                GLOBAL SETTINGS
                                            </TableCell>
                                        </TableRow>
                                        {createDesignRow(
                                            "Design Options Available",
                                            null,
                                            "design_types",
                                            null,
                                            "JSON"
                                        )}
                                        {createDesignRow("Job Settings", null, "job_settings", null, "auto")}
                                        {createDesignRow("Role Access", null, "role_access", null, "JSON")}
                                        {createDesignRow("Attachment Types", null, "attachment_types", null, "JSON")}
                                        {createDesignRow(
                                            "ROOFSHEET GROUPS",
                                            null,
                                            "roofsheet_types",
                                            null,
                                            roofSheetFormat,
                                            null,
                                            true,
                                            true
                                        )}
                                        {createDesignRow(
                                            "STATIC DOCUMENTS",
                                            null,
                                            "static_documents",
                                            null,
                                            "JSON",
                                            null,
                                            true
                                        )}
                                        {createDesignRow(
                                            "BOM ITEMS (ALL JOBS)",
                                            null,
                                            "bom_items_for_each_job",
                                            null,
                                            bomFormat,
                                            null,
                                            true
                                        )}
                                        {createDesignRow(
                                            "NON MODIFIABLE ITEMS",
                                            null,
                                            "cannot_delete_codes",
                                            null,
                                            "array",
                                            product_codes
                                        )}
                                        {createDesignRow("DRAWINGS", null, "drawings", null, drawingFormat, null, true)}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                    </AppBar>

                    <Popper
                        key={editCell}
                        anchorEl={editCell?.anchorEl}
                        placement="bottom-start"
                        open={editCell?.anchorEl}
                        disablePortal={false}
                        modifiers={{
                            flip: {
                                enabled: true,
                            },
                            preventOverflow: {
                                enabled: true,
                                boundariesElement: "scrollParent",
                            },
                            arrow: {
                                enabled: true,
                                element: editCell?.anchorEl,
                            },
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                            <Paper
                                style={{
                                    padding: "0px 5px 5px 5px",
                                    background: "rgb(255 179 67 / 96%)",
                                    textAlign: "center",
                                    paddingTop: "2px",
                                    minWidth: "50px",
                                    maxHeight: "500px",
                                }}
                            >
                                <div
                                    id="draggable-dialog-title"
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "19px",
                                    }}
                                >
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <div className={classes.drag_bar} />
                                        <div className={classes.drag_bar} />
                                        <div className={classes.drag_bar} />
                                    </div>
                                </div>
                                <IconButton
                                    aria-label="delete"
                                    size="small"
                                    onClick={() => setEditCell(null)}
                                    style={{ color: "white", position: "absolute", right: "5px" }}
                                >
                                    <CloseIcon />
                                </IconButton>
                                {editorType === "select" && (
                                    <>
                                        <SegmentedButtonGroup
                                            label={editCell?.title}
                                            style={{ width: "300px", flex: "none" }}
                                            value={value}
                                            tight={true}
                                            items={editCell?.autocomplete_list ? editCell?.autocomplete_list : []}
                                            onChange={(e, val) => {
                                                setValue(val);
                                                e.stopPropagation();
                                            }}
                                        />

                                        <BSL_Button onClick={() => saveValue(editCell.POA, editCell.key_path, value)}>
                                            UPDATE
                                        </BSL_Button>
                                    </>
                                )}
                                {editorType === "range" && (
                                    <>
                                        <BSL_ControlContainer label={editCell?.title}>
                                            <BSL_TextInput
                                                label={"MIN"}
                                                style={{ width: "200px", color: "white" }}
                                                value={value?.min}
                                                min={0}
                                                max={999999}
                                                autoFocus
                                                tight={true}
                                                preValidate={"numbersOnly"}
                                                onEnter={(e) => setValue({ ...value, min: Number(e.target.value) })}
                                                onChange={(val) => setValue({ ...value, min: Number(val) })}
                                            />
                                            <BSL_TextInput
                                                label={"MAX"}
                                                style={{ width: "200px", color: "white" }}
                                                value={value?.max}
                                                min={0}
                                                max={999999}
                                                autoFocus
                                                tight={true}
                                                preValidate={"numbersOnly"}
                                                onEnter={(e) => setValue({ ...value, max: Number(e.target.value) })}
                                                onChange={(val) => setValue({ ...value, max: Number(val) })}
                                            />
                                            <BSL_TextInput
                                                label={"DEFAULT"}
                                                style={{ width: "200px", color: "white" }}
                                                value={value?.default}
                                                min={0}
                                                max={999999}
                                                autoFocus
                                                tight={true}
                                                preValidate={"numbersOnly"}
                                                onEnter={(e) => setValue({ ...value, default: Number(e.target.value) })}
                                                onChange={(val) => setValue({ ...value, default: Number(val) })}
                                            />
                                        </BSL_ControlContainer>

                                        <BSL_Button onClick={() => saveValue(editCell.POA, editCell.key_path, value)}>
                                            UPDATE
                                        </BSL_Button>
                                    </>
                                )}
                                {editorType === "shape" && (
                                    <>
                                        <BSL_ControlContainer label={editCell?.title}>
                                            {Object.entries(editCell.value)
                                                .filter(([key]) =>
                                                    ["Length", "Depth", "Height", "RoofPitch"].includes(key)
                                                )
                                                .map(([key, val]) => (
                                                    <BSL_TextInput
                                                        label={key}
                                                        style={{ width: "200px", color: "white" }}
                                                        value={value?.[key]}
                                                        min={0}
                                                        max={999999}
                                                        autoFocus
                                                        tight={true}
                                                        preValidate={"numbersOnly"}
                                                        onEnter={(e) =>
                                                            setValue({ ...value, [key]: Number(e.target.value) })
                                                        }
                                                        onChange={(v) => setValue({ ...value, [key]: Number(v) })}
                                                    />
                                                ))}
                                            <BSL_Button
                                                onClick={() => saveValue(editCell.POA, editCell.key_path, value)}
                                            >
                                                UPDATE
                                            </BSL_Button>
                                        </BSL_ControlContainer>
                                    </>
                                )}

                                {editorType === "beams_and_posts" && (
                                    <>
                                        <BSL_ControlContainer label={editCell?.title}>
                                            <BSL_Select
                                                label={"Fascia"}
                                                id={"dropdown-BeamType1"}
                                                tight={true}
                                                value={value?.["BeamType1"] || ""}
                                                onChange={(e) => setValue({ ...value, ["BeamType1"]: e.target.value })}
                                                items={editCell?.autocomplete_list[0]}
                                            ></BSL_Select>
                                            <BSL_Select
                                                label={"Purlin"}
                                                id={"dropdown-BeamType2"}
                                                tight={true}
                                                value={value?.["BeamType2"] || ""}
                                                onChange={(e) => setValue({ ...value, ["BeamType2"]: e.target.value })}
                                                items={editCell?.autocomplete_list[0]}
                                            ></BSL_Select>
                                            <BSL_Select
                                                label={"Rafter"}
                                                id={"dropdown-BeamType3"}
                                                tight={true}
                                                value={value?.["BeamType3"] || ""}
                                                onChange={(e) => setValue({ ...value, ["BeamType3"]: e.target.value })}
                                                items={editCell?.autocomplete_list[0]}
                                            ></BSL_Select>
                                            <BSL_Select
                                                label={"Post"}
                                                id={"dropdown-PostType"}
                                                tight={true}
                                                value={value?.["PostType"] || ""}
                                                onChange={(e) => setValue({ ...value, ["PostType"]: e.target.value })}
                                                items={editCell?.autocomplete_list[1]}
                                            ></BSL_Select>
                                            <BSL_Button
                                                onClick={() => saveValue(editCell.POA, editCell.key_path, value)}
                                            >
                                                UPDATE
                                            </BSL_Button>
                                        </BSL_ControlContainer>
                                    </>
                                )}

                                {editorType === "text" && (
                                    <>
                                        <Autocomplete
                                            items={editCell?.autocomplete_list ? editCell?.autocomplete_list : []}
                                            shouldItemRender={(item, value) => {
                                                if (item.toLowerCase().startsWith(value.toLowerCase().substring(0, 3)))
                                                    return true;
                                                if (item.toLowerCase().indexOf(value.toLowerCase()) > -1) return true;
                                                return false;
                                            }}
                                            autoHighlight={false}
                                            getItemValue={(item) => item}
                                            renderItem={(item, highlighted) => (
                                                <div
                                                    key={item.id}
                                                    style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                                >
                                                    {item}
                                                </div>
                                            )}
                                            wrapperStyle={
                                                {
                                                    // zIndex: "0",
                                                }
                                            }
                                            menuStyle={{
                                                zIndex: "999999",
                                                position: "absolute",
                                                backgroundColor: "whitesmoke",
                                                boxShadow: "1px 1px 4px",
                                                fontSize: "12px",
                                                left: "auto",
                                                top: "auto",
                                                marginLeft: "9px",
                                                marginTop: "0px",
                                                textAlign: "left",
                                                maxHeight: "250px",
                                                overflowY: "auto",
                                            }}
                                            inputProps={{
                                                style: {
                                                    zIndex: "1",
                                                    font: "200 12px Univers45",
                                                    width: "95%",
                                                    padding: "4px 0px 4px 8px !important",
                                                },
                                            }}
                                            renderInput={(props) => {
                                                return (
                                                    <BSL_TextInput
                                                        label={editCell?.title}
                                                        style={{
                                                            width: "200px",
                                                            color: "white",
                                                            margin: "0px",
                                                            padding: "0px",
                                                        }}
                                                        placeholder={"Add Value..."}
                                                        value={value}
                                                        // autoFocus
                                                        tight={true}
                                                        InputProps={{
                                                            style: { fontSize: "80%" },
                                                            ...props,
                                                        }}
                                                        onEnter={(e) => {
                                                            setValue(e.target.value);
                                                        }}
                                                    />
                                                );
                                            }}
                                            value={value}
                                            onChange={(e) => {
                                                setValue(e.target.value);
                                            }}
                                            onSelect={(val) => {
                                                setValue(val);
                                            }}
                                        />

                                        <BSL_Button onClick={() => saveValue(editCell.POA, editCell.key_path, value)}>
                                            UPDATE
                                        </BSL_Button>
                                    </>
                                )}
                                {editorType === "array" && (
                                    <>
                                        <BSL_ControlContainer label={editCell?.title}>
                                            {createArrayEditor(value)}
                                        </BSL_ControlContainer>

                                        <BSL_Button onClick={() => saveValue(editCell.POA, editCell.key_path, value)}>
                                            UPDATE
                                        </BSL_Button>
                                    </>
                                )}
                                {editorType === "collection" && (
                                    <>
                                        <BSL_ControlContainer label={editCell?.title}>
                                            {Object.keys(value).map((key) => {
                                                return (
                                                    <>
                                                        <div
                                                            style={{
                                                                display: "inline-flex",
                                                            }}
                                                        >
                                                            <BSL_TextInput
                                                                label={"Subheading"}
                                                                style={{
                                                                    width: "200px",
                                                                    color: "white",
                                                                    margin: "0px",
                                                                    padding: "0px",
                                                                }}
                                                                value={key}
                                                                // autoFocus
                                                                tight={true}
                                                                InputProps={{
                                                                    style: { fontSize: "80%" },
                                                                    ...props,
                                                                }}
                                                                onEnter={(e) => {
                                                                    let new_key = e.target.value;

                                                                    new_key = new_key.replace(/[^\w\s/'/-/(/)]/gi, "");
                                                                    if (new_key && new_key != key) {
                                                                        let newValue = JSON.stringify(value);
                                                                        newValue = newValue.replace(
                                                                            '"' + key + '":',
                                                                            '"' + new_key + '":'
                                                                        );
                                                                        setValue(JSON.parse(newValue));
                                                                    }
                                                                }}
                                                                onBlur={(val) => {
                                                                    let new_key = val;
                                                                    new_key = new_key.replace(/[^\w\s/'/-/(/)]/gi, "");
                                                                    if (new_key && new_key != key) {
                                                                        let newValue = JSON.stringify(value);
                                                                        newValue = newValue.replace(
                                                                            '"' + key + '":',
                                                                            '"' + new_key + '":'
                                                                        );
                                                                        setValue(JSON.parse(newValue));
                                                                    }
                                                                }}
                                                            />
                                                            <IconButton
                                                                aria-label="delete"
                                                                size="small"
                                                                onClick={() => {
                                                                    let new_value = { ...value };
                                                                    delete new_value[key];
                                                                    setValue(new_value);
                                                                }}
                                                                style={{}}
                                                            >
                                                                <CloseIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </div>
                                                        {createArrayEditor(value[key], key)}
                                                    </>
                                                );
                                            })}
                                        </BSL_ControlContainer>
                                        <BSL_TextInput
                                            placeholder={"Add New Section"}
                                            style={{
                                                width: "200px",
                                                color: "white",
                                                margin: "0px",
                                                padding: "0px",
                                            }}
                                            value={value2}
                                            // autoFocus
                                            tight={true}
                                            InputProps={{
                                                style: { fontSize: "80%" },
                                                ...props,
                                            }}
                                            onEnter={(e) => {
                                                let new_key = e.target.value;
                                                new_key = new_key.replace(/[^\w\s/'/-/(/)]/gi, "");
                                                if (new_key) {
                                                    let newValue = { ...value };
                                                    newValue[new_key] = [];
                                                    setValue(newValue);
                                                }
                                                setValue2("");
                                            }}
                                            onBlur={(val) => {
                                                let new_key = val;
                                                new_key = new_key.replace(/[^\w\s/'/-/(/)]/gi, "");
                                                if (new_key) {
                                                    let newValue = { ...value };
                                                    newValue[new_key] = [];
                                                    setValue(newValue);
                                                }
                                                setValue2("");
                                            }}
                                        />

                                        <BSL_Button onClick={() => saveValue(editCell.POA, editCell.key_path, value)}>
                                            UPDATE
                                        </BSL_Button>
                                    </>
                                )}
                                {editorType === "BOM" && (
                                    <ManageProductListAncillary
                                        value={value}
                                        mode="OFFERING"
                                        offering_editcell={editCell}
                                        onClose={() => setEditCell(null)}
                                        saveValue={saveValue}
                                        pricefileDescSummary={pricefileDescSummary}
                                    />
                                )}
                                {editorType === "bom_filter" && (
                                    <ManageProductListFilter
                                        value={value}
                                        offering_editcell={editCell}
                                        onClose={() => setEditCell(null)}
                                        saveValue={saveValue}
                                        pricefileDescSummary={pricefileDescSummary}
                                    />
                                )}
                                {editorType === "JSON" && (
                                    <BSL_Dialog
                                        title={"Edit JSON for " + editCell?.title}
                                        open={true}
                                        button1Text="Update"
                                        button1Click={() => {
                                            if (!jsonValid) {
                                                alert(
                                                    "JSON is not valid. You cannot save this data. Fix it up and try again."
                                                );
                                            } else {
                                                saveValue(editCell.POA, editCell.key_path, JSON.parse(value));
                                            }
                                        }}
                                        button2Text="Cancel"
                                        button2Click={() => setEditCell(null)}
                                        style={{ maxWidth: "initial", height: "95vh" }}
                                        contentStyle={{ maxWidth: "initial", height: "95vh" }}
                                        fullWidth={true}
                                        maxWidth={"md"}
                                    >
                                        <textarea
                                            id="w3review"
                                            name="w3review"
                                            style={{
                                                backgroundColor: "beige",
                                                fontFamily: "monospace",
                                                padding: "10px",
                                                borderRadius: "9px",
                                                color: "#444444",
                                                // maxHeight: "400px",
                                                overflowY: "auto",
                                                fontSize: "12px",
                                                width: "100%",
                                                height: "90%",
                                            }}
                                            // rows="75"
                                            cols="75"
                                            onChange={(e) => {
                                                setValue(e.target.value);
                                                setJSONValid(checkValidJSON(e.target.value));
                                            }}
                                            onBlur={(e) => {
                                                let valid = checkValidJSON(e.target.value);
                                                setJSONValid(valid);
                                                if (valid) {
                                                    setValue(JSON.stringify(JSON.parse(e.target.value), null, 4));
                                                }
                                            }}
                                            value={
                                                value
                                                    ? typeof value === "object"
                                                        ? JSON.stringify(value, null, 4)
                                                        : value
                                                    : "{}"
                                            }
                                        />
                                        <div
                                            style={{
                                                color: jsonValid ? "green" : "red",
                                                fontSize: "12px",
                                                padding: "10px",
                                                textAlign: "center",
                                            }}
                                        >
                                            {jsonValid ? "VALID JSON" : "NOT VALID JSON"}
                                        </div>
                                    </BSL_Dialog>
                                )}
                                {editorType === "pricing_tier" && (
                                    <>
                                        <ManagePricing editCell={editCell} value={value} saveValue={saveValue} />
                                    </>
                                )}
                                {editorType === "roofsheet_default" && (
                                    <>
                                        <SegmentedButtonGroup
                                            label={editCell?.title}
                                            style={{ width: "300px", flex: "none" }}
                                            value={value?.grouptype ? value?.grouptype : ""}
                                            tight={true}
                                            items={roofsheet_group_types}
                                            onChange={(e, val) => {
                                                let new_value = value ? { ...value } : {};
                                                new_value.grouptype = val;
                                                setValue(new_value);
                                                e.stopPropagation();
                                            }}
                                        />
                                        <SegmentedButtonGroup
                                            label={editCell?.title}
                                            style={{ width: "300px", flex: "none" }}
                                            value={value?.subtype ? value?.subtype : ""}
                                            tight={true}
                                            items={
                                                value?.grouptype
                                                    ? master?.roofsheet_types?.[value?.grouptype]?.subtypes
                                                    : []
                                            }
                                            onChange={(e, val) => {
                                                let new_value = value ? { ...value } : {};
                                                new_value.subtype = val;
                                                setValue(new_value);
                                                e.stopPropagation();
                                            }}
                                        />

                                        <BSL_Button onClick={() => saveValue(editCell.POA, editCell.key_path, value)}>
                                            UPDATE
                                        </BSL_Button>
                                    </>
                                )}
                            </Paper>
                        </Draggable>
                    </Popper>
                </>
            )}
        </div>
    );
}
